// import React from 'react';
// import {
//   Container,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Box,
// } from '@mui/material';

// const HomeContent = () => {
//   return (
//     <Box
//       sx={{
//         background: 'linear-gradient(135deg, #f5f7fa, #c3cfe2)', // Gradient background
//         py: 6,
//       }}
//     >
//       <Container maxWidth="lg">
//         {/* Hero Section */}
//         <Box sx={{ textAlign: 'center', mb: 6 }}>
//           <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
//             Welcome to Exam Ace
//           </Typography>
//           <Typography variant="h6" color="text.secondary">
//             Your one-stop platform for academic management.
//           </Typography>
//         </Box>

//         {/* Feature Cards */}
//         <Grid container spacing={4}>
//           {[
//             {
//               title: 'Assignment Management',
//               description: 'View, submit, and track your assignments.',
//             },
//             {
//               title: 'Quiz Administration',
//               description: 'Take quizzes and track your progress.',
//             },
//             {
//               title: 'Live Chat & AI Chatbot',
//               description: 'Connect with teachers or get instant support.',
//             },
//             {
//               title: 'Notices & Announcements',
//               description: 'Stay updated with important notices.',
//             },
//             {
//               title: 'Internship Updates',
//               description: 'Explore internship opportunities.',
//             },
//             {
//               title: 'Academic Calendar',
//               description: 'Plan your schedule effectively.',
//             },
//           ].map((feature, index) => (
//             <Grid item xs={12} sm={6} md={4} key={index}>
//               <Card
//                 sx={{
//                   minHeight: 200,
//                   display: 'flex',
//                   flexDirection: 'column',
//                   justifyContent: 'center',
//                   alignItems: 'center',
//                   bgcolor: 'background.paper',
//                   borderRadius: 2,
//                   boxShadow: 3,
//                   background: 'linear-gradient(145deg, #ffffff, #f0f0f0)', // Gradient card background
//                   transition: 'transform 0.3s, box-shadow 0.3s',
//                   '&:hover': {
//                     transform: 'scale(1.05)',
//                     boxShadow: 6,
//                   },
//                 }}
//               >
//                 <CardContent sx={{ textAlign: 'center' }}>
//                   <Typography variant="h5" component="div" sx={{ fontWeight: 'bold', mb: 2 }}>
//                     {feature.title}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                     {feature.description}
//                   </Typography>
//                   {/* <Button variant="contained" color="primary" sx={{ mt: 2 }}>
//                     Learn More
//                   </Button> */}
//                 </CardContent>
//               </Card>
//             </Grid>
//           ))}
//         </Grid>
//       </Container>
//     </Box>
//   );
// };

// export default HomeContent;

// import React, { useEffect, useRef } from 'react';
// import {
//   Container,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Box,
//   alpha,
//   useTheme,
//   Chip
// } from '@mui/material';
// import {
//   Assignment,
//   Quiz,
//   Chat,
//   Announcement,
//   Work,
//   CalendarToday,
//   RocketLaunch,
//   School,
//   TrendingUp,
//   SupportAgent,
//   AutoAwesome,
//   Star,
//   ArrowForward
// } from '@mui/icons-material';
// import { motion } from 'framer-motion';
// import { styled, keyframes } from '@mui/material/styles';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

// // Register GSAP plugins
// gsap.registerPlugin(ScrollTrigger);

// // Animations
// const float = keyframes`
//   0%, 100% { transform: translateY(0px); }
//   50% { transform: translateY(-10px); }
// `;

// const shimmer = keyframes`
//   0% { background-position: -200% 0; }
//   100% { background-position: 200% 0; }
// `;

// const pulse = keyframes`
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.05); }
// `;


// const rotate = keyframes`
//   from { transform: rotate(0deg); }
//   to { transform: rotate(360deg); }
// `;

// // Styled Components
// const FeatureCard = styled(Card)(({ theme }) => ({
//   minHeight: 320,
//   display: 'flex',
//   flexDirection: 'column',
//   justifyContent: 'center',
//   alignItems: 'center',
//   background: 'rgba(255, 255, 255, 0.9)',
//   borderRadius: '24px',
//   backdropFilter: 'blur(20px)',
//   border: '1px solid rgba(255, 255, 255, 0.3)',
//   boxShadow: '0 15px 50px rgba(0, 0, 0, 0.08)',
//   transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//   position: 'relative',
//   overflow: 'hidden',
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     height: '4px',
//     background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
//     transform: 'scaleX(0)',
//     transition: 'transform 0.3s ease',
//   },
//   '&:hover': {
//     transform: 'translateY(-12px) scale(1.02)',
//     boxShadow: '0 25px 60px rgba(0, 0, 0, 0.15)',
//     '&::before': {
//       transform: 'scaleX(1)',
//     },
//   },
// }));

// const IconContainer = styled(Box)(({ color }) => ({
//   display: 'inline-flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   width: 90,
//   height: 90,
//   borderRadius: '24px',
//   background: `linear-gradient(135deg, ${color} 0%, ${alpha(color, 0.7)} 100%)`,
//   color: 'white',
//   mb: 3,
//   boxShadow: `0 12px 30px ${alpha(color, 0.3)}`,
//   position: 'relative',
//   overflow: 'hidden',
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.2) 50%, transparent 70%)',
//     transform: 'translateX(-100%)',
//     transition: 'transform 0.6s ease',
//   },
//   '&:hover::before': {
//     transform: 'translateX(100%)',
//   },
// }));

// const StatsCard = styled(Box)(({ theme }) => ({
//   textAlign: 'center',
//   p: 4,
//   background: 'rgba(255, 255, 255, 0.8)',
//   borderRadius: '20px',
//   backdropFilter: 'blur(15px)',
//   border: '1px solid rgba(255, 255, 255, 0.3)',
//   boxShadow: '0 12px 40px rgba(0, 0, 0, 0.08)',
//   transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//   position: 'relative',
//   overflow: 'hidden',
//   '&:hover': {
//     transform: 'translateY(-8px)',
//     boxShadow: '0 20px 50px rgba(0, 0, 0, 0.12)',
//   },
// }));

// const CTASection = styled(Box)({
//   textAlign: 'center',
//   p: 8,
//   background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//   borderRadius: '32px',
//   color: 'white',
//   boxShadow: '0 25px 70px rgba(102, 126, 234, 0.4)',
//   position: 'relative',
//   overflow: 'hidden',
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
//     animation: `${rotate} 20s linear infinite`,
//   },
// });

// const LearnMoreButton = styled(Button)({
//   borderRadius: '16px',
//   borderWidth: '2px',
//   fontWeight: 600,
//   textTransform: 'none',
//   position: 'relative',
//   overflow: 'hidden',
//   transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//   '&:hover': {
//     borderWidth: '2px',
//     transform: 'translateY(-2px)',
//     boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
//   },
// });

// const HomeContent = () => {
//   const theme = useTheme();
//   const containerRef = useRef(null);

//   // GSAP animations
//   useEffect(() => {
//     if (!containerRef.current) return;

//     // Animate feature cards
//     const cards = containerRef.current.querySelectorAll('.feature-card');
//     gsap.fromTo(cards, 
//       {
//         scale: 0.8,
//         opacity: 0,
//         y: 100
//       },
//       {
//         scale: 1,
//         opacity: 1,
//         y: 0,
//         duration: 1,
//         stagger: 0.1,
//         ease: 'power2.out',
//         scrollTrigger: {
//           trigger: cards,
//           start: 'top 80%',
//           end: 'top 60%',
//           toggleActions: 'play none none reverse'
//         }
//       }
//     );

//     // Animate stats cards
//     const statsCards = containerRef.current.querySelectorAll('.stats-card');
//     gsap.fromTo(statsCards,
//       {
//         scale: 0.9,
//         opacity: 0,
//         y: 50
//       },
//       {
//         scale: 1,
//         opacity: 1,
//         y: 0,
//         duration: 0.8,
//         stagger: 0.2,
//         ease: 'power2.out',
//         scrollTrigger: {
//           trigger: statsCards,
//           start: 'top 85%',
//           end: 'top 70%',
//           toggleActions: 'play none none reverse'
//         }
//       }
//     );

//     // Animate text elements
//     const textElements = containerRef.current.querySelectorAll('.text-animate');
//     gsap.fromTo(textElements,
//       {
//         y: 50,
//         opacity: 0
//       },
//       {
//         y: 0,
//         opacity: 1,
//         duration: 1,
//         stagger: 0.1,
//         ease: 'power2.out',
//         scrollTrigger: {
//           trigger: textElements,
//           start: 'top 80%',
//           end: 'top 60%',
//           toggleActions: 'play none none reverse'
//         }
//       }
//     );

//     // Floating background elements
//     gsap.to('.floating-bg-1', {
//       y: -30,
//       duration: 4,
//       ease: 'power1.inOut',
//       yoyo: true,
//       repeat: -1
//     });

//     gsap.to('.floating-bg-2', {
//       y: 30,
//       duration: 5,
//       ease: 'power1.inOut',
//       yoyo: true,
//       repeat: -1
//     });

//     return () => {
//       ScrollTrigger.getAll().forEach(trigger => trigger.kill());
//     };
//   }, []);
  
//   const features = [
//     {
//       title: 'Assignment Management',
//       description: 'View, submit, and track your assignments with ease. Get real-time updates and notifications.',
//       icon: <Assignment sx={{ fontSize: 48 }} />,
//       color: '#667eea',
//       badge: 'Popular',
//       stats: '500+ Assignments'
//     },
//     {
//       title: 'Quiz Administration',
//       description: 'Take quizzes and track your progress in real-time with detailed analytics.',
//       icon: <Quiz sx={{ fontSize: 48 }} />,
//       color: '#f093fb',
//       badge: 'New',
//       stats: '95% Success Rate'
//     },
//     {
//       title: 'Live Chat & AI Support',
//       description: 'Connect with teachers or get instant AI-powered support 24/7.',
//       icon: <Chat sx={{ fontSize: 48 }} />,
//       color: '#ff6b6b',
//       badge: 'AI Powered',
//       stats: 'Instant Response'
//     },
//     {
//       title: 'Notices & Announcements',
//       description: 'Stay updated with important notices and announcements from your institution.',
//       icon: <Announcement sx={{ fontSize: 48 }} />,
//       color: '#4ecdc4',
//       badge: 'Updated',
//       stats: 'Real-time Updates'
//     },
//     {
//       title: 'Internship Opportunities',
//       description: 'Explore and apply for internship opportunities from top companies.',
//       icon: <Work sx={{ fontSize: 48 }} />,
//       color: '#ffd166',
//       badge: 'Featured',
//       stats: '100+ Companies'
//     },
//     {
//       title: 'Academic Calendar',
//       description: 'Plan your schedule effectively with our comprehensive calendar system.',
//       icon: <CalendarToday sx={{ fontSize: 48 }} />,
//       color: '#6a0572',
//       badge: 'Smart',
//       stats: 'Auto Sync'
//     },
//   ];

//   const stats = [
//     { number: '10K+', label: 'Active Students', icon: <School sx={{ fontSize: 40 }} />, color: '#667eea' },
//     { number: '95%', label: 'Success Rate', icon: <TrendingUp sx={{ fontSize: 40 }} />, color: '#4ecdc4' },
//     { number: '24/7', label: 'Support', icon: <SupportAgent sx={{ fontSize: 40 }} />, color: '#ff6b6b' },
//   ];

//   // Animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.1
//       }
//     }
//   };

//   const cardVariants = {
//     hidden: { opacity: 0, y: 50, scale: 0.8 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       scale: 1,
//       transition: {
//         duration: 0.6,
//         ease: "easeOut"
//       }
//     }
//   };

//   const titleVariants = {
//     hidden: { opacity: 0, y: 30 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: {
//         duration: 0.8,
//         ease: "easeOut"
//       }
//     }
//   };

//   return (
//     <Box
//       ref={containerRef}
//       sx={{
//         background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
//         minHeight: '100vh',
//         py: 8,
//         position: 'relative',
//         overflow: 'hidden',
//         width: '100%',
//         '&::before': {
//           content: '""',
//           position: 'absolute',
//           width: '400px',
//           height: '400px',
//           background: 'radial-gradient(circle, rgba(102,126,234,0.1) 0%, transparent 70%)',
//           top: '-200px',
//           right: '-200px',
//           borderRadius: '50%',
//           animation: `${float} 6s ease-in-out infinite`,
//         },
//         '&::after': {
//           content: '""',
//           position: 'absolute',
//           width: '300px',
//           height: '300px',
//           background: 'radial-gradient(circle, rgba(240,147,251,0.08) 0%, transparent 70%)',
//           bottom: '-150px',
//           left: '-150px',
//           borderRadius: '50%',
//           animation: `${float} 8s ease-in-out infinite reverse`,
//         }
//       }}
//     >
//       <Box sx={{ 
//         position: 'relative', 
//         zIndex: 1,
//         maxWidth: '1200px',
//         margin: '0 auto',
//         width: '100%',
//         px: 2
//       }}>
//         {/* Enhanced Hero Section */}
//         <motion.div
//           variants={titleVariants}
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//         >
//           <Box sx={{ 
//             textAlign: 'center', 
//             mb: 12,
//             position: 'relative'
//           }}>
//             <motion.div
//               initial={{ scale: 0.8, opacity: 0 }}
//               animate={{ scale: 1, opacity: 1 }}
//               transition={{ duration: 0.8, delay: 0.2 }}
//             >
//               <Typography 
//                 variant="h2" 
//                 component="h1" 
//                 gutterBottom 
//                 sx={{ 
//                   fontWeight: '800', 
//                   background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
//                   WebkitBackgroundClip: 'text',
//                   WebkitTextFillColor: 'transparent',
//                   backgroundSize: '200% 200%',
//                   animation: `${shimmer} 3s ease-in-out infinite`,
//                   mb: 3,
//                   fontSize: { xs: '2.5rem', md: '4rem' },
//                   lineHeight: 1.2
//                 }}
//               >
//                 Welcome to Exam Ace
//               </Typography>
//             </motion.div>
            
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6, delay: 0.4 }}
//             >
//               <Typography 
//                 variant="h5" 
//                 color="text.secondary" 
//                 sx={{ 
//                   maxWidth: '700px', 
//                   mx: 'auto',
//                   mb: 6,
//                   fontSize: { xs: '1.1rem', md: '1.4rem' },
//                   lineHeight: 1.6
//                 }}
//               >
//                 Your comprehensive platform for academic excellence and management. 
//                 Transform your learning experience with cutting-edge tools and resources.
//               </Typography>
//             </motion.div>

//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6, delay: 0.6 }}
//             >
//               <Button
//                 variant="contained"
//                 size="large"
//                 startIcon={<AutoAwesome />}
//                 sx={{
//                   background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                   borderRadius: '20px',
//                   px: 6,
//                   py: 2,
//                   fontSize: '1.2rem',
//                   fontWeight: '700',
//                   textTransform: 'none',
//                   boxShadow: '0 12px 35px rgba(102, 126, 234, 0.4)',
//                   '&:hover': {
//                     boxShadow: '0 18px 45px rgba(102, 126, 234, 0.6)',
//                     transform: 'translateY(-3px) scale(1.05)'
//                   },
//                   transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
//                 }}
//               >
//                 Get Started Today
//               </Button>
//             </motion.div>
//           </Box>
//         </motion.div>

//         {/* Enhanced Stats Section */}
//         <motion.div
//           variants={containerVariants}
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//         >
//           <Grid container spacing={4} sx={{ mb: 12 }}>
//             {stats.map((stat, index) => (
//               <Grid item xs={12} md={4} key={index}>
//                 <motion.div variants={cardVariants}>
//                   <StatsCard>
//                     <Box sx={{ 
//                       display: 'inline-flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       width: 80,
//                       height: 80,
//                       borderRadius: '24px',
//                       background: `linear-gradient(135deg, ${stat.color} 0%, ${alpha(stat.color, 0.7)} 100%)`,
//                       color: 'white',
//                       mb: 3,
//                       boxShadow: `0 12px 30px ${alpha(stat.color, 0.3)}`,
//                       animation: `${pulse} 3s ease-in-out infinite`
//                     }}>
//                       {stat.icon}
//                     </Box>
//                     <Typography variant="h3" component="div" sx={{ 
//                       fontWeight: '800', 
//                       mb: 2,
//                       background: `linear-gradient(135deg, ${stat.color} 0%, ${alpha(stat.color, 0.8)} 100%)`,
//                       WebkitBackgroundClip: 'text',
//                       WebkitTextFillColor: 'transparent'
//                     }}>
//                       {stat.number}
//                     </Typography>
//                     <Typography variant="h6" color="text.secondary" sx={{ fontWeight: '600' }}>
//                       {stat.label}
//                     </Typography>
//                   </StatsCard>
//                 </motion.div>
//               </Grid>
//             ))}
//           </Grid>
//         </motion.div>

//         {/* Enhanced Feature Cards */}
//         <motion.div
//           variants={titleVariants}
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//         >
//           <Typography 
//             variant="h3" 
//             component="h2" 
//             sx={{ 
//               textAlign: 'center', 
//               mb: 8, 
//               fontWeight: '800',
//               color: 'text.primary',
//               fontSize: { xs: '2rem', md: '3rem' }
//             }}
//           >
//             Everything You Need For
//             <Box component="span" sx={{ 
//               background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//               WebkitBackgroundClip: 'text',
//               WebkitTextFillColor: 'transparent',
//               display: 'block'
//             }}>
//               Academic Success
//             </Box>
//           </Typography>
//         </motion.div>
        
//         <motion.div
//           variants={containerVariants}
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//         >
//           <Grid container spacing={4}>
//             {features.map((feature, index) => (
//               <Grid item xs={12} sm={6} md={4} key={index}>
//                 <motion.div variants={cardVariants}>
//                   <FeatureCard>
//                     <CardContent sx={{ textAlign: 'center', width: '100%', p: 4 }}>
//                       {/* Badge */}
//                       <Chip
//                         label={feature.badge}
//                         size="small"
//                         sx={{
//                           background: `linear-gradient(135deg, ${feature.color} 0%, ${alpha(feature.color, 0.8)} 100%)`,
//                           color: 'white',
//                           fontWeight: 'bold',
//                           mb: 2,
//                           animation: `${pulse} 2s ease-in-out infinite`
//                         }}
//                       />
                      
//                       {/* Icon */}
//                       <IconContainer color={feature.color}>
//                         {feature.icon}
//                       </IconContainer>
                      
//                       {/* Title */}
//                       <Typography 
//                         variant="h5" 
//                         component="div" 
//                         sx={{ 
//                           fontWeight: '700', 
//                           mb: 2,
//                           color: 'text.primary',
//                           fontSize: { xs: '1.3rem', md: '1.5rem' }
//                         }}
//                       >
//                         {feature.title}
//                       </Typography>
                      
//                       {/* Description */}
//                       <Typography 
//                         variant="body1" 
//                         color="text.secondary" 
//                         sx={{ 
//                           mb: 3,
//                           lineHeight: 1.7,
//                           fontSize: '1rem'
//                         }}
//                       >
//                         {feature.description}
//                       </Typography>
                      
//                       {/* Stats */}
//                       <Typography 
//                         variant="body2" 
//                         sx={{ 
//                           color: feature.color,
//                           fontWeight: '600',
//                           mb: 3,
//                           fontSize: '0.9rem'
//                         }}
//                       >
//                         {feature.stats}
//                       </Typography>
                      
//                       {/* Learn More Button */}
//                       <LearnMoreButton 
//                         variant="outlined"
//                         endIcon={<ArrowForward />}
//                         sx={{
//                           borderColor: feature.color,
//                           color: feature.color,
//                           '&:hover': {
//                             backgroundColor: feature.color,
//                             color: 'white',
//                             borderColor: feature.color,
//                           }
//                         }}
//                       >
//                         Learn More
//                       </LearnMoreButton>
//                     </CardContent>
//                   </FeatureCard>
//                 </motion.div>
//               </Grid>
//             ))}
//           </Grid>
//         </motion.div>

//         {/* Enhanced CTA Section */}
//         <motion.div
//           initial={{ opacity: 0, y: 50 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           viewport={{ once: true }}
//         >
//           <CTASection sx={{ mt: 12 }}>
//             <motion.div
//               animate={{ 
//                 y: [0, -10, 0],
//                 rotate: [0, 2, -2, 0]
//               }}
//               transition={{ 
//                 repeat: Infinity, 
//                 duration: 4,
//                 ease: "easeInOut"
//               }}
//             >
//               <RocketLaunch sx={{ fontSize: 80, mb: 4 }} />
//             </motion.div>
            
//             <Typography variant="h3" component="h3" gutterBottom sx={{ 
//               fontWeight: '800',
//               mb: 3,
//               fontSize: { xs: '2rem', md: '3rem' }
//             }}>
//               Ready to Transform Your Academic Journey?
//             </Typography>
            
//             <Typography variant="h6" sx={{ 
//               mb: 6, 
//               maxWidth: '700px', 
//               mx: 'auto', 
//               opacity: 0.9,
//               lineHeight: 1.6,
//               fontSize: { xs: '1.1rem', md: '1.3rem' }
//             }}>
//               Join thousands of students who are already achieving their academic goals with Exam Ace. 
//               Start your journey to academic excellence today!
//             </Typography>
            
//             <Button
//               variant="contained"
//               size="large"
//               startIcon={<Star />}
//               sx={{
//                 background: 'white',
//                 color: '#667eea',
//                 borderRadius: '20px',
//                 px: 6,
//                 py: 2,
//                 fontSize: '1.2rem',
//                 fontWeight: '700',
//                 textTransform: 'none',
//                 boxShadow: '0 12px 35px rgba(255, 255, 255, 0.3)',
//                 '&:hover': {
//                   background: 'rgba(255, 255, 255, 0.95)',
//                   boxShadow: '0 18px 45px rgba(255, 255, 255, 0.4)',
//                   transform: 'translateY(-3px) scale(1.05)'
//                 },
//                 transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
//               }}
//             >
//               Sign Up Now
//             </Button>
//           </CTASection>
//         </motion.div>
//       </Box>
//     </Box>
//   );
// };

// export default HomeContent;

// import React, { useEffect, useRef } from 'react';
// import {
//   Container,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Box,
//   alpha,
//   useTheme,
//   Chip,
//   Avatar,
//   Divider,
//   Paper
// } from '@mui/material';
// import {
//   Assignment,
//   Quiz,
//   Chat,
//   Announcement,
//   Work,
//   CalendarToday,
//   RocketLaunch,
//   School,
//   TrendingUp,
//   SupportAgent,
//   AutoAwesome,
//   Star,
//   ArrowForward,
//   CheckCircle,
//   Psychology,
//   Speed,
//   Security
// } from '@mui/icons-material';
// import { motion } from 'framer-motion';
// import { styled, keyframes } from '@mui/material/styles';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

// // Register GSAP plugins
// gsap.registerPlugin(ScrollTrigger);

// // Professional animations
// const gentleFloat = keyframes`
//   0%, 100% { transform: translateY(0px) rotate(0deg); }
//   50% { transform: translateY(-6px) rotate(1deg); }
// `;

// const subtleShimmer = keyframes`
//   0% { background-position: -200% 0; }
//   100% { background-position: 200% 0; }
// `;

// const breathe = keyframes`
//   0%, 100% { transform: scale(1); opacity: 1; }
//   50% { transform: scale(1.02); opacity: 0.9; }
// `;

// const slideInGradient = keyframes`
//   0% { background-position: 0% 50%; }
//   50% { background-position: 100% 50%; }
//   100% { background-position: 0% 50%; }
// `;

// // Professional color palette
// const colors = {
//   primary: '#1e40af',        // Deep professional blue
//   primaryLight: '#3b82f6',   // Lighter blue
//   secondary: '#374151',      // Professional gray
//   accent: '#0284c7',         // Sky blue
//   success: '#059669',        // Emerald
//   warning: '#d97706',        // Amber
//   error: '#dc2626',          // Red
//   background: '#f8fafc',     // Off-white background
//   backgroundAlt: '#f1f5f9',  // Alternate background
//   card: '#ffffff',           // Pure white cards
//   surface: '#f9fafb',        // Surface color
//   textPrimary: '#111827',    // Near black
//   textSecondary: '#6b7280',  // Medium gray
//   border: '#e5e7eb',         // Light border
//   shadow: 'rgba(0, 0, 0, 0.04)',
//   shadowHover: 'rgba(0, 0, 0, 0.12)'
// };

// // Enhanced styled components
// const FeatureCard = styled(Card)({
//   height: '100%',
//   display: 'flex',
//   flexDirection: 'column',
//   background: colors.card,
//   borderRadius: '20px',
//   border: `1px solid ${colors.border}`,
//   boxShadow: `0 4px 24px ${colors.shadow}`,
//   transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//   position: 'relative',
//   overflow: 'hidden',
//   '&:hover': {
//     transform: 'translateY(-12px)',
//     boxShadow: `0 20px 60px ${colors.shadowHover}`,
//   },
// });

// const IconContainer = styled(Box)(({ color }) => ({
//   display: 'inline-flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   width: 72,
//   height: 72,
//   borderRadius: '18px',
//   background: `linear-gradient(135deg, ${color} 0%, ${alpha(color, 0.8)} 100%)`,
//   color: 'white',
//   marginBottom: '24px',
//   boxShadow: `0 12px 32px ${alpha(color, 0.2)}`,
//   position: 'relative',
//   overflow: 'hidden',
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: '-50%',
//     left: '-50%',
//     width: '200%',
//     height: '200%',
//     background: 'linear-gradient(45deg, transparent, rgba(255,255,255,0.1), transparent)',
//     transform: 'rotate(45deg)',
//     transition: 'all 0.6s ease',
//     opacity: 0,
//   },
//   '&:hover::before': {
//     opacity: 1,
//     animation: 'shine 1.5s ease-in-out',
//   },
//   '@keyframes shine': {
//     '0%': { transform: 'rotate(45deg) translate(-100%, -100%)' },
//     '100%': { transform: 'rotate(45deg) translate(100%, 100%)' },
//   }
// }));

// const StatsCard = styled(Paper)(({ theme }) => ({
//   textAlign: 'center',
//   padding: '32px 24px',
//   background: colors.card,
//   borderRadius: '20px',
//   border: `1px solid ${colors.border}`,
//   boxShadow: `0 4px 24px ${colors.shadow}`,
//   transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//   position: 'relative',
//   overflow: 'hidden',
//   '&:hover': {
//     transform: 'translateY(-8px)',
//     boxShadow: `0 16px 48px ${colors.shadowHover}`,
//   },
// }));

// const HeroSection = styled(Box)({
//   background: `linear-gradient(135deg, ${colors.background} 0%, ${colors.backgroundAlt} 100%)`,
//   borderRadius: '32px',
//   padding: '80px 40px',
//   marginBottom: '80px',
//   position: 'relative',
//   overflow: 'hidden',
//   border: `1px solid ${colors.border}`,
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     width: '400px',
//     height: '400px',
//     background: `radial-gradient(circle, ${alpha(colors.primary, 0.04)} 0%, transparent 70%)`,
//     top: '-200px',
//     right: '-200px',
//     borderRadius: '50%',
//     animation: `${gentleFloat} 8s ease-in-out infinite`,
//   },
//   '&::after': {
//     content: '""',
//     position: 'absolute',
//     width: '300px',
//     height: '300px',
//     background: `radial-gradient(circle, ${alpha(colors.accent, 0.03)} 0%, transparent 70%)`,
//     bottom: '-150px',
//     left: '-150px',
//     borderRadius: '50%',
//     animation: `${gentleFloat} 10s ease-in-out infinite reverse`,
//   }
// });

// const CTASection = styled(Box)({
//   textAlign: 'center',
//   padding: '80px 60px',
//   background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryLight} 50%, ${colors.accent} 100%)`,
//   backgroundSize: '200% 200%',
//   animation: `${slideInGradient} 6s ease infinite`,
//   borderRadius: '32px',
//   color: 'white',
//   boxShadow: `0 24px 80px ${alpha(colors.primary, 0.25)}`,
//   position: 'relative',
//   overflow: 'hidden',
//   border: `1px solid ${alpha('#ffffff', 0.1)}`,
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'url("data:image/svg+xml,%3Csvg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.02"%3E%3Ccircle cx="50" cy="50" r="1"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
//   },
// });

// const GlassCard = styled(Card)({
//   background: alpha('#ffffff', 0.7),
//   backdropFilter: 'blur(20px)',
//   border: `1px solid ${alpha('#ffffff', 0.2)}`,
//   borderRadius: '20px',
//   boxShadow: `0 8px 32px ${alpha(colors.primary, 0.1)}`,
// });

// // Component for feature card with hover effect
// const EnhancedFeatureCard = ({ feature, index }) => {
//   const cardRef = useRef(null);

//   const handleMouseEnter = () => {
//     if (cardRef.current) {
//       // Add top border gradient on hover
//       cardRef.current.style.borderTop = `3px solid ${feature.color}`;
//     }
//   };

//   const handleMouseLeave = () => {
//     if (cardRef.current) {
//       // Remove top border on leave
//       cardRef.current.style.borderTop = 'none';
//     }
//   };

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 50 }}
//       whileInView={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.6, delay: index * 0.1 }}
//       viewport={{ once: true }}
//     >
//       <FeatureCard 
//         ref={cardRef}
//         className="feature-card" 
//         elevation={0}
//         onMouseEnter={handleMouseEnter}
//         onMouseLeave={handleMouseLeave}
//       >
//         <CardContent sx={{ p: 4, height: '100%', display: 'flex', flexDirection: 'column' }}>
//           <Box sx={{ mb: 'auto' }}>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
//               <Chip
//                 label={feature.badge}
//                 size="small"
//                 sx={{
//                   background: `linear-gradient(135deg, ${feature.color} 0%, ${alpha(feature.color, 0.8)} 100%)`,
//                   color: 'white',
//                   fontWeight: '600',
//                   fontSize: '0.75rem',
//                   height: '24px'
//                 }}
//               />
//             </Box>
            
//             <IconContainer color={feature.color}>
//               {feature.icon}
//             </IconContainer>
            
//             <Typography 
//               variant="h5" 
//               component="h3" 
//               sx={{ 
//                 fontWeight: '700', 
//                 mb: 2,
//                 color: colors.textPrimary,
//                 fontSize: '1.25rem',
//                 lineHeight: 1.3
//               }}
//             >
//               {feature.title}
//             </Typography>
            
//             <Typography 
//               variant="body1" 
//               color={colors.textSecondary} 
//               sx={{ 
//                 mb: 3,
//                 lineHeight: 1.6,
//                 fontSize: '0.95rem'
//               }}
//             >
//               {feature.description}
//             </Typography>

//             <Box sx={{ mb: 3 }}>
//               {feature.benefits.map((benefit, idx) => (
//                 <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                   <CheckCircle sx={{ fontSize: 16, color: feature.color, mr: 1 }} />
//                   <Typography variant="body2" color={colors.textSecondary} sx={{ fontSize: '0.85rem' }}>
//                     {benefit}
//                   </Typography>
//                 </Box>
//               ))}
//             </Box>

//             <Divider sx={{ mb: 3 }} />
//           </Box>
          
//           <Box sx={{ mt: 'auto' }}>
//             <Typography 
//               variant="body2" 
//               sx={{ 
//                 color: feature.color,
//                 fontWeight: '600',
//                 mb: 3,
//                 fontSize: '0.85rem'
//               }}
//             >
//               {feature.stats}
//             </Typography>
            
//             <Button 
//               variant="contained"
//               endIcon={<ArrowForward />}
//               fullWidth
//               sx={{
//                 background: `linear-gradient(135deg, ${feature.color} 0%, ${alpha(feature.color, 0.8)} 100%)`,
//                 borderRadius: '12px',
//                 py: 1.5,
//                 fontWeight: '600',
//                 textTransform: 'none',
//                 '&:hover': {
//                   background: `linear-gradient(135deg, ${alpha(feature.color, 0.9)} 0%, ${alpha(feature.color, 0.7)} 100%)`,
//                   transform: 'translateY(-1px)',
//                   boxShadow: `0 8px 25px ${alpha(feature.color, 0.3)}`
//                 },
//                 transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
//               }}
//             >
//               Explore Feature
//             </Button>
//           </Box>
//         </CardContent>
//       </FeatureCard>
//     </motion.div>
//   );
// };

// const HomeContent = () => {
//   const theme = useTheme();
//   const containerRef = useRef(null);

//   // Enhanced GSAP animations with text visibility fixes
//   useEffect(() => {
//     if (!containerRef.current) return;

//     // Smooth entrance animations for cards only
//     const cards = containerRef.current.querySelectorAll('.feature-card');
//     gsap.fromTo(cards, 
//       {
//         scale: 0.98,
//         opacity: 0.3,
//         y: 30
//       },
//       {
//         scale: 1,
//         opacity: 1,
//         y: 0,
//         duration: 0.8,
//         stagger: 0.1,
//         ease: 'power2.out',
//         scrollTrigger: {
//           trigger: cards,
//           start: 'top 90%',
//           toggleActions: 'play none none none'
//         }
//       }
//     );

//     const statsCards = containerRef.current.querySelectorAll('.stats-card');
//     gsap.fromTo(statsCards,
//       {
//         scale: 0.98,
//         opacity: 0.3,
//         y: 20
//       },
//       {
//         scale: 1,
//         opacity: 1,
//         y: 0,
//         duration: 0.6,
//         stagger: 0.1,
//         ease: 'power2.out',
//         scrollTrigger: {
//           trigger: statsCards,
//           start: 'top 95%',
//           toggleActions: 'play none none none'
//         }
//       }
//     );

//     return () => {
//       ScrollTrigger.getAll().forEach(trigger => trigger.kill());
//     };
//   }, []);
  
//   const features = [
//     {
//       title: 'Smart Assignment Management',
//       description: 'Intelligently organize, submit, and track assignments with AI-powered insights and automated reminders for optimal productivity.',
//       icon: <Assignment sx={{ fontSize: 32 }} />,
//       color: colors.primary,
//       badge: 'AI Enhanced',
//       stats: '98% On-time Submission',
//       benefits: ['Real-time tracking', 'Smart notifications', 'Progress analytics']
//     },
//     {
//       title: 'Advanced Quiz Platform',
//       description: 'Experience interactive quizzes with detailed analytics, adaptive learning paths, and instant performance feedback.',
//       icon: <Quiz sx={{ fontSize: 32 }} />,
//       color: colors.accent,
//       badge: 'Adaptive',
//       stats: '15% Better Scores',
//       benefits: ['Instant feedback', 'Adaptive difficulty', 'Performance insights']
//     },
//     {
//       title: 'AI-Powered Support',
//       description: 'Get instant help with our advanced AI assistant and connect with expert tutors for personalized academic guidance.',
//       icon: <Psychology sx={{ fontSize: 32 }} />,
//       color: colors.success,
//       badge: 'Next-Gen AI',
//       stats: '24/7 Availability',
//       benefits: ['Instant responses', 'Expert tutors', 'Personalized help']
//     },
//     {
//       title: 'Smart Notifications',
//       description: 'Stay informed with intelligent notifications that prioritize important updates and reduce information overload.',
//       icon: <Announcement sx={{ fontSize: 32 }} />,
//       color: colors.warning,
//       badge: 'Smart',
//       stats: '90% Less Noise',
//       benefits: ['Priority filtering', 'Custom alerts', 'Smart scheduling']
//     },
//     {
//       title: 'Career Opportunities',
//       description: 'Access exclusive internships and job opportunities from top companies with AI-matched recommendations.',
//       icon: <Work sx={{ fontSize: 32 }} />,
//       color: colors.error,
//       badge: 'Exclusive',
//       stats: '200+ Partners',
//       benefits: ['AI matching', 'Top companies', 'Career guidance']
//     },
//     {
//       title: 'Intelligent Calendar',
//       description: 'Optimize your schedule with AI-powered planning that adapts to your learning patterns and preferences.',
//       icon: <CalendarToday sx={{ fontSize: 32 }} />,
//       color: colors.secondary,
//       badge: 'Optimized',
//       stats: '30% More Efficient',
//       benefits: ['Auto-scheduling', 'Conflict resolution', 'Smart reminders']
//     },
//   ];

//   const stats = [
//     { 
//       number: '25K+', 
//       label: 'Active Students', 
//       icon: <School sx={{ fontSize: 40 }} />, 
//       color: colors.primary,
//       description: 'Growing community'
//     },
//     { 
//       number: '97%', 
//       label: 'Success Rate', 
//       icon: <TrendingUp sx={{ fontSize: 40 }} />, 
//       color: colors.success,
//       description: 'Proven results'
//     },
//     { 
//       number: '24/7', 
//       label: 'AI Support', 
//       icon: <SupportAgent sx={{ fontSize: 40 }} />, 
//       color: colors.accent,
//       description: 'Always available'
//     },
//   ];

//   const trustIndicators = [
//     { icon: <Security />, label: 'Enterprise Security' },
//     { icon: <Speed />, label: 'Lightning Fast' },
//     { icon: <CheckCircle />, label: 'Proven Results' },
//   ];

//   return (
//     <Box
//       ref={containerRef}
//       sx={{
//         background: colors.background,
//         minHeight: '100vh',
//         py: { xs: 6, md: 10 },
//         position: 'relative',
//         overflow: 'hidden',
//       }}
//     >
//       <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
//         {/* Enhanced Hero Section */}
//         <HeroSection>
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8 }}
//           >
//             <Box sx={{ textAlign: 'center', position: 'relative', zIndex: 2 }}>
//               <motion.div
//                 initial={{ scale: 0.9, opacity: 0 }}
//                 animate={{ scale: 1, opacity: 1 }}
//                 transition={{ duration: 0.8, delay: 0.2 }}
//               >
//                 <Typography 
//                   variant="h1" 
//                   component="h1" 
//                   sx={{ 
//                     fontWeight: '800', 
//                     background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 50%, ${colors.primary} 100%)`,
//                     backgroundSize: '200% 200%',
//                     animation: `${slideInGradient} 4s ease infinite`,
//                     WebkitBackgroundClip: 'text',
//                     WebkitTextFillColor: 'transparent',
//                     mb: 3,
//                     fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4.5rem' },
//                     lineHeight: 1.1,
//                     letterSpacing: '-0.02em'
//                   }}
//                 >
//                   Transform Your
//                   <br />
//                   Academic Journey
//                 </Typography>
//               </motion.div>
              
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: 0.4 }}
//               >
//                 <Typography 
//                   variant="h5" 
//                   color={colors.textSecondary}
//                   sx={{ 
//                     maxWidth: '800px', 
//                     mx: 'auto',
//                     mb: 6,
//                     fontSize: { xs: '1.1rem', md: '1.4rem' },
//                     lineHeight: 1.6,
//                     fontWeight: 400
//                   }}
//                 >
//                   Experience the future of education with AI-powered tools, personalized learning paths, 
//                   and comprehensive academic management in one intelligent platform.
//                 </Typography>
//               </motion.div>

//               {/* Trust indicators */}
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: 0.5 }}
//               >
//                 <Box sx={{ display: 'flex', justifyContent: 'center', gap: 4, mb: 6, flexWrap: 'wrap' }}>
//                   {trustIndicators.map((item, index) => (
//                     <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <Box sx={{ color: colors.primary }}>{item.icon}</Box>
//                       <Typography variant="body2" color={colors.textSecondary} sx={{ fontWeight: 500 }}>
//                         {item.label}
//                       </Typography>
//                     </Box>
//                   ))}
//                 </Box>
//               </motion.div>

//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: 0.6 }}
//               >
//                 <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center', flexWrap: 'wrap' }}>
//                   <Button
//                     variant="contained"
//                     size="large"
//                     startIcon={<AutoAwesome />}
//                     sx={{
//                       background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryLight} 100%)`,
//                       borderRadius: '16px',
//                       px: 4,
//                       py: 1.8,
//                       fontSize: '1.1rem',
//                       fontWeight: '600',
//                       textTransform: 'none',
//                       boxShadow: `0 12px 40px ${alpha(colors.primary, 0.3)}`,
//                       '&:hover': {
//                         boxShadow: `0 16px 50px ${alpha(colors.primary, 0.4)}`,
//                         transform: 'translateY(-2px)'
//                       },
//                       transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
//                     }}
//                   >
//                     Start Free Trial
//                   </Button>
                  
//                   <Button
//                     variant="outlined"
//                     size="large"
//                     sx={{
//                       borderColor: colors.primary,
//                       color: colors.primary,
//                       borderRadius: '16px',
//                       px: 4,
//                       py: 1.8,
//                       fontSize: '1.1rem',
//                       fontWeight: '600',
//                       textTransform: 'none',
//                       borderWidth: '2px',
//                       '&:hover': {
//                         borderWidth: '2px',
//                         backgroundColor: alpha(colors.primary, 0.05),
//                         transform: 'translateY(-2px)'
//                       },
//                       transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
//                     }}
//                   >
//                     Watch Demo
//                   </Button>
//                 </Box>
//               </motion.div>
//             </Box>
//           </motion.div>
//         </HeroSection>

//         {/* Enhanced Stats Section */}
//         <Grid container spacing={4} sx={{ mb: 12 }}>
//           {stats.map((stat, index) => (
//             <Grid item xs={12} md={4} key={index}>
//               <motion.div
//                 initial={{ opacity: 0, y: 40 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: index * 0.1 }}
//                 viewport={{ once: true }}
//               >
//                 <StatsCard className="stats-card" elevation={0}>
//                   <Box sx={{ 
//                     display: 'inline-flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     width: 80,
//                     height: 80,
//                     borderRadius: '20px',
//                     background: `linear-gradient(135deg, ${stat.color} 0%, ${alpha(stat.color, 0.8)} 100%)`,
//                     color: 'white',
//                     mb: 3,
//                     boxShadow: `0 16px 40px ${alpha(stat.color, 0.2)}`,
//                   }}>
//                     {stat.icon}
//                   </Box>
//                   <Typography variant="h2" component="div" sx={{ 
//                     fontWeight: '800', 
//                     mb: 1,
//                     color: colors.textPrimary,
//                     fontSize: { xs: '2.5rem', md: '3rem' }
//                   }}>
//                     {stat.number}
//                   </Typography>
//                   <Typography variant="h6" color={colors.textPrimary} sx={{ fontWeight: '600', mb: 1 }}>
//                     {stat.label}
//                   </Typography>
//                   <Typography variant="body2" color={colors.textSecondary}>
//                     {stat.description}
//                   </Typography>
//                 </StatsCard>
//               </motion.div>
//             </Grid>
//           ))}
//         </Grid>

//         {/* Enhanced Features Section */}
//         <Box sx={{ textAlign: 'center', mb: 8 }}>
//           <Typography 
//             variant="h2" 
//             component="h2" 
//             sx={{ 
//               fontWeight: '800',
//               color: colors.textPrimary,
//               fontSize: { xs: '2rem', md: '3rem' },
//               mb: 3,
//               letterSpacing: '-0.01em'
//             }}
//           >
//             Powerful Features for
//             <Box component="span" sx={{ 
//               background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`,
//               WebkitBackgroundClip: 'text',
//               WebkitTextFillColor: 'transparent',
//               display: 'block'
//             }}>
//               Modern Education
//             </Box>
//           </Typography>
          
//           <Typography 
//             variant="h6" 
//             color={colors.textSecondary} 
//             sx={{ 
//               maxWidth: '600px', 
//               mx: 'auto',
//               fontWeight: 400,
//               lineHeight: 1.6
//             }}
//           >
//             Discover cutting-edge tools designed to enhance learning outcomes and streamline academic management.
//           </Typography>
//         </Box>
        
//         <Grid container spacing={4}>
//           {features.map((feature, index) => (
//             <Grid item xs={12} sm={6} md={4} key={index}>
//               <EnhancedFeatureCard feature={feature} index={index} />
//             </Grid>
//           ))}
//         </Grid>

//         {/* Enhanced CTA Section */}
//         <motion.div
//           initial={{ opacity: 0, y: 50 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           viewport={{ once: true }}
//         >
//           <CTASection sx={{ mt: 12 }}>
//             <Box sx={{ position: 'relative', zIndex: 2 }}>
//               <motion.div
//                 animate={{ 
//                   y: [0, -8, 0],
//                 }}
//                 transition={{ 
//                   repeat: Infinity, 
//                   duration: 4,
//                   ease: "easeInOut"
//                 }}
//               >
//                 <RocketLaunch sx={{ fontSize: 64, mb: 4 }} />
//               </motion.div>
              
//               <Typography variant="h2" component="h3" sx={{ 
//                 fontWeight: '800',
//                 mb: 3,
//                 fontSize: { xs: '2rem', md: '2.75rem' },
//                 letterSpacing: '-0.01em'
//               }}>
//                 Ready to Excel in Your Studies?
//               </Typography>
              
//               <Typography variant="h6" sx={{ 
//                 mb: 6, 
//                 maxWidth: '700px', 
//                 mx: 'auto', 
//                 opacity: 0.95,
//                 lineHeight: 1.6,
//                 fontSize: { xs: '1rem', md: '1.2rem' },
//                 fontWeight: 400
//               }}>
//                 Join over 25,000 students who have transformed their academic performance with our 
//                 comprehensive platform. Start your success story today.
//               </Typography>
              
//               <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center', flexWrap: 'wrap' }}>
//                 <Button
//                   variant="contained"
//                   size="large"
//                   startIcon={<Star />}
//                   sx={{
//                     background: 'white',
//                     color: colors.primary,
//                     borderRadius: '16px',
//                     px: 5,
//                     py: 2,
//                     fontSize: '1.1rem',
//                     fontWeight: '700',
//                     textTransform: 'none',
//                     boxShadow: '0 12px 40px rgba(255, 255, 255, 0.2)',
//                     '&:hover': {
//                       background: 'rgba(255, 255, 255, 0.95)',
//                       boxShadow: '0 16px 50px rgba(255, 255, 255, 0.3)',
//                       transform: 'translateY(-2px)'
//                     },
//                     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
//                   }}
//                 >
//                   Get Started Free
//                 </Button>
                
//                 <Button
//                   variant="outlined"
//                   size="large"
//                   sx={{
//                     borderColor: 'rgba(255, 255, 255, 0.3)',
//                     color: 'white',
//                     borderRadius: '16px',
//                     px: 5,
//                     py: 2,
//                     fontSize: '1.1rem',
//                     fontWeight: '600',
//                     textTransform: 'none',
//                     borderWidth: '2px',
//                     backdropFilter: 'blur(10px)',
//                     background: 'rgba(255, 255, 255, 0.1)',
//                     '&:hover': {
//                       borderWidth: '2px',
//                       borderColor: 'rgba(255, 255, 255, 0.5)',
//                       background: 'rgba(255, 255, 255, 0.2)',
//                       transform: 'translateY(-2px)'
//                     },
//                     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
//                   }}
//                 >
//                   Schedule Demo
//                 </Button>
//               </Box>

//               {/* Social proof */}
//               <Box sx={{ mt: 6, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, opacity: 0.8 }}>
//                 <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
//                   Trusted by students from
//                 </Typography>
//                 <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
//                   {['Harvard', 'MIT', 'Stanford', 'Oxford'].map((univ, idx) => (
//                     <Typography key={idx} variant="body2" sx={{ 
//                       fontWeight: 600, 
//                       fontSize: '0.9rem',
//                       opacity: 0.9
//                     }}>
//                       {univ}
//                     </Typography>
//                   ))}
//                 </Box>
//               </Box>
//             </Box>
//           </CTASection>
//         </motion.div>

//         {/* Enhanced testimonial section */}
//         <Box sx={{ mt: 12, textAlign: 'center' }}>
//           <Typography variant="h3" sx={{ 
//             fontWeight: '800', 
//             mb: 6,
//             color: colors.textPrimary,
//             fontSize: { xs: '1.75rem', md: '2.5rem' }
//           }}>
//             What Students Say
//           </Typography>
          
//           <Grid container spacing={4}>
//             {[
//               {
//                 name: 'Sarah Chen',
//                 role: 'Computer Science Student',
//                 avatar: 'S',
//                 quote: 'ExamAce transformed my study routine. The AI insights helped me identify weak areas and improve my grades by 25%.',
//                 rating: 5
//               },
//               {
//                 name: 'Michael Rodriguez',
//                 role: 'Business Major',
//                 avatar: 'M',
//                 quote: 'The assignment management system is incredible. I never miss deadlines and stay organized effortlessly.',
//                 rating: 5
//               },
//               {
//                 name: 'Emily Watson',
//                 role: 'Medical Student',
//                 avatar: 'E',
//                 quote: 'The 24/7 AI support saved me during exam season. Getting instant help when studying late made all the difference.',
//                 rating: 5
//               }
//             ].map((testimonial, index) => (
//               <Grid item xs={12} md={4} key={index}>
//                 <motion.div
//                   initial={{ opacity: 0, y: 30 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.6, delay: index * 0.1 }}
//                   viewport={{ once: true }}
//                 >
//                   <GlassCard sx={{ p: 4, height: '100%' }}>
//                     <Box sx={{ display: 'flex', mb: 3 }}>
//                       {[...Array(testimonial.rating)].map((_, i) => (
//                         <Star key={i} sx={{ color: colors.warning, fontSize: 20 }} />
//                       ))}
//                     </Box>
                    
//                     <Typography variant="body1" sx={{ 
//                       mb: 4, 
//                       fontStyle: 'italic',
//                       color: colors.textSecondary,
//                       lineHeight: 1.6
//                     }}>
//                       "{testimonial.quote}"
//                     </Typography>
                    
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                       <Avatar sx={{ 
//                         bgcolor: colors.primary,
//                         width: 48,
//                         height: 48,
//                         fontWeight: 600
//                       }}>
//                         {testimonial.avatar}
//                       </Avatar>
//                       <Box>
//                         <Typography variant="subtitle1" sx={{ 
//                           fontWeight: 600,
//                           color: colors.textPrimary
//                         }}>
//                           {testimonial.name}
//                         </Typography>
//                         <Typography variant="body2" color={colors.textSecondary}>
//                           {testimonial.role}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </GlassCard>
//                 </motion.div>
//               </Grid>
//             ))}
//           </Grid>
//         </Box>

//         {/* Footer section with additional info */}
//         <Box sx={{ mt: 16, pt: 8, borderTop: `1px solid ${colors.border}` }}>
//           <Grid container spacing={6}>
//             <Grid item xs={12} md={4}>
//               <Typography variant="h6" sx={{ 
//                 fontWeight: '700', 
//                 mb: 3,
//                 color: colors.textPrimary
//               }}>
//                 Platform Features
//               </Typography>
//               <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
//                 {['AI-Powered Analytics', 'Real-time Collaboration', 'Mobile App Access', 'Cloud Sync'].map((feature, idx) => (
//                   <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                     <CheckCircle sx={{ fontSize: 16, color: colors.success }} />
//                     <Typography variant="body2" color={colors.textSecondary}>
//                       {feature}
//                     </Typography>
//                   </Box>
//                 ))}
//               </Box>
//             </Grid>
            
//             <Grid item xs={12} md={4}>
//               <Typography variant="h6" sx={{ 
//                 fontWeight: '700', 
//                 mb: 3,
//                 color: colors.textPrimary
//               }}>
//                 Security & Privacy
//               </Typography>
//               <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
//                 {['End-to-End Encryption', 'GDPR Compliant', 'SOC 2 Certified', '99.9% Uptime'].map((security, idx) => (
//                   <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                     <Security sx={{ fontSize: 16, color: colors.primary }} />
//                     <Typography variant="body2" color={colors.textSecondary}>
//                       {security}
//                     </Typography>
//                   </Box>
//                 ))}
//               </Box>
//             </Grid>
            
//             <Grid item xs={12} md={4}>
//               <Typography variant="h6" sx={{ 
//                 fontWeight: '700', 
//                 mb: 3,
//                 color: colors.textPrimary
//               }}>
//                 Support & Resources
//               </Typography>
//               <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
//                 {['24/7 Live Chat', 'Video Tutorials', 'Community Forum', 'API Documentation'].map((support, idx) => (
//                   <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                     <SupportAgent sx={{ fontSize: 16, color: colors.accent }} />
//                     <Typography variant="body2" color={colors.textSecondary}>
//                       {support}
//                     </Typography>
//                   </Box>
//                 ))}
//               </Box>
//             </Grid>
//           </Grid>
          
//           <Divider sx={{ my: 6 }} />
          
//           <Box sx={{ textAlign: 'center' }}>
//             <Typography variant="body2" color={colors.textSecondary} sx={{ mb: 2 }}>
//               © 2025 ExamAce. All rights reserved.
//             </Typography>
//             <Typography variant="body2" color={colors.textSecondary}>
//               Empowering students worldwide with intelligent academic tools.
//             </Typography>
//           </Box>
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default HomeContent;


// import React, { useEffect, useRef, useState } from 'react';
// import {
//   Container,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Box,
//   alpha,
//   useTheme,
//   Chip,
//   Avatar,
//   Divider,
//   Paper,
//   LinearProgress,
//   IconButton,
//   Tooltip
// } from '@mui/material';
// import {
//   Assignment,
//   Quiz,
//   Chat,
//   Announcement,
//   Work,
//   CalendarToday,
//   RocketLaunch,
//   School,
//   TrendingUp,
//   SupportAgent,
//   AutoAwesome,
//   Star,
//   ArrowForward,
//   CheckCircle,
//   Psychology,
//   Speed,
//   Security,
//   PlayArrow,
//   Lightbulb,
//   Groups,
//   Analytics,
//   CloudSync,
//   MobileFriendly,
//   LiveHelp,
//   BookmarkBorder,
//   Favorite,
//   Share,
//   ExpandMore,
//   ChevronRight
// } from '@mui/icons-material';
// import { motion, AnimatePresence } from 'framer-motion';
// import { styled, keyframes } from '@mui/material/styles';

// // Enhanced animations matching Home component style
// const gentleFloat = keyframes`
//   0%, 100% { transform: translateY(0px) rotate(0deg); }
//   50% { transform: translateY(-8px) rotate(1deg); }
// `;

// const subtleShimmer = keyframes`
//   0% { background-position: -200% 0; }
//   100% { background-position: 200% 0; }
// `;

// const breathe = keyframes`
//   0%, 100% { transform: scale(1); opacity: 1; }
//   50% { transform: scale(1.03); opacity: 0.95; }
// `;

// const slideInGradient = keyframes`
//   0% { background-position: 0% 50%; }
//   50% { background-position: 100% 50%; }
//   100% { background-position: 0% 50%; }
// `;

// const ripple = keyframes`
//   0% { transform: scale(0); opacity: 1; }
//   100% { transform: scale(4); opacity: 0; }
// `;

// const glowPulse = keyframes`
//   0%, 100% { box-shadow: 0 0 20px rgba(30, 64, 175, 0.2); }
//   50% { box-shadow: 0 0 30px rgba(30, 64, 175, 0.4), 0 0 40px rgba(30, 64, 175, 0.2); }
// `;

// // Enhanced color palette matching Home component
// const colors = {
//   primary: '#1e40af',
//   primaryLight: '#3b82f6',
//   primaryDark: '#1e3a8a',
//   secondary: '#374151',
//   accent: '#0284c7',
//   accentLight: '#0ea5e9',
//   success: '#059669',
//   successLight: '#10b981',
//   warning: '#d97706',
//   warningLight: '#f59e0b',
//   error: '#dc2626',
//   errorLight: '#ef4444',
//   purple: '#7c3aed',
//   purpleLight: '#8b5cf6',
//   pink: '#db2777',
//   pinkLight: '#ec4899',
//   background: '#f8fafc',
//   backgroundAlt: '#f1f5f9',
//   card: '#ffffff',
//   surface: '#f9fafb',
//   textPrimary: '#111827',
//   textSecondary: '#6b7280',
//   border: '#e5e7eb',
//   borderLight: '#f3f4f6',
//   shadow: 'rgba(0, 0, 0, 0.04)',
//   shadowHover: 'rgba(0, 0, 0, 0.12)',
//   overlay: 'rgba(255, 255, 255, 0.8)'
// };

// // Enhanced styled components matching Home component
// const InteractiveFeatureCard = styled(Card)(({ theme, featured }) => ({
//   height: '100%',
//   display: 'flex',
//   flexDirection: 'column',
//   background: featured 
//     ? `linear-gradient(135deg, ${alpha(colors.primary, 0.02)} 0%, ${alpha(colors.accent, 0.02)} 100%)`
//     : colors.card,
//   borderRadius: '24px',
//   border: featured 
//     ? `2px solid ${alpha(colors.primary, 0.1)}`
//     : `1px solid ${colors.border}`,
//   boxShadow: featured
//     ? `0 8px 40px ${alpha(colors.primary, 0.12)}`
//     : `0 4px 24px ${colors.shadow}`,
//   transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
//   position: 'relative',
//   overflow: 'hidden',
//   cursor: 'pointer',
//   '&:hover': {
//     transform: 'translateY(-16px) scale(1.02)',
//     boxShadow: `0 25px 80px ${colors.shadowHover}`,
//     '& .card-actions': {
//       opacity: 1,
//       transform: 'translateY(0)',
//     },
//     '& .feature-progress': {
//       width: '100%',
//     },
//     '& .hover-overlay': {
//       opacity: 1,
//     }
//   },
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     height: featured ? '4px' : '2px',
//     background: featured
//       ? `linear-gradient(90deg, ${colors.primary}, ${colors.accent}, ${colors.primary})`
//       : `linear-gradient(90deg, transparent, ${colors.primary}, transparent)`,
//     backgroundSize: '200% 100%',
//     animation: `${subtleShimmer} 3s ease-in-out infinite`,
//     opacity: 0,
//     transition: 'opacity 0.3s ease',
//   },
//   '&:hover::before': {
//     opacity: 1,
//   }
// }));

// const EnhancedIconContainer = styled(Box)(({ color, animated }) => ({
//   display: 'inline-flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   width: 80,
//   height: 80,
//   borderRadius: '24px',
//   background: `linear-gradient(135deg, ${color} 0%, ${alpha(color, 0.8)} 100%)`,
//   color: 'white',
//   marginBottom: '24px',
//   boxShadow: `0 16px 40px ${alpha(color, 0.25)}`,
//   position: 'relative',
//   overflow: 'hidden',
//   animation: animated ? `${glowPulse} 3s ease-in-out infinite` : 'none',
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: '-50%',
//     left: '-50%',
//     width: '200%',
//     height: '200%',
//     background: 'linear-gradient(45deg, transparent, rgba(255,255,255,0.15), transparent)',
//     transform: 'rotate(45deg)',
//     transition: 'all 0.6s ease',
//     opacity: 0,
//   },
//   '&:hover::before': {
//     opacity: 1,
//     animation: 'shine 1.5s ease-in-out',
//   },
//   '@keyframes shine': {
//     '0%': { transform: 'rotate(45deg) translate(-100%, -100%)' },
//     '100%': { transform: 'rotate(45deg) translate(100%, 100%)' },
//   }
// }));

// const StatsCard = styled(Paper)(({ theme, gradient }) => ({
//   textAlign: 'center',
//   padding: '40px 32px',
//   background: gradient || colors.card,
//   borderRadius: '24px',
//   border: `1px solid ${colors.border}`,
//   boxShadow: `0 8px 32px ${colors.shadow}`,
//   transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//   position: 'relative',
//   overflow: 'hidden',
//   '&:hover': {
//     transform: 'translateY(-12px)',
//     boxShadow: `0 20px 60px ${colors.shadowHover}`,
//     '& .stats-icon': {
//       transform: 'scale(1.1) rotate(5deg)',
//     }
//   },
// }));

// const GradientCTASection = styled(Box)({
//   textAlign: 'center',
//   padding: '100px 80px',
//   background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryLight} 30%, ${colors.accent} 70%, ${colors.accentLight} 100%)`,
//   backgroundSize: '300% 300%',
//   animation: `${slideInGradient} 8s ease infinite`,
//   borderRadius: '40px',
//   color: 'white',
//   boxShadow: `0 30px 100px ${alpha(colors.primary, 0.3)}`,
//   position: 'relative',
//   overflow: 'hidden',
//   border: `1px solid ${alpha('#ffffff', 0.15)}`,
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="30" cy="30" r="1"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
//   },
// });

// const InteractiveButton = styled(Button)(({ variant: buttonVariant, color }) => ({
//   borderRadius: '16px',
//   padding: '12px 32px',
//   fontSize: '1.1rem',
//   fontWeight: '600',
//   textTransform: 'none',
//   position: 'relative',
//   overflow: 'hidden',
//   transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     width: 0,
//     height: 0,
//     backgroundColor: alpha('#ffffff', 0.2),
//     borderRadius: '50%',
//     transform: 'translate(-50%, -50%)',
//     transition: 'width 0.6s, height 0.6s',
//   },
//   '&:active::before': {
//     width: '300px',
//     height: '300px',
//   },
//   '&:hover': {
//     transform: 'translateY(-2px)',
//   }
// }));

// // Enhanced feature card component with more interactivity
// const SuperFeatureCard = ({ feature, index, onLike, onBookmark, onShare }) => {
//   const [liked, setLiked] = useState(false);
//   const [bookmarked, setBookmarked] = useState(false);
//   const [expanded, setExpanded] = useState(false);
//   const cardRef = useRef(null);

//   const handleLike = (e) => {
//     e.stopPropagation();
//     setLiked(!liked);
//     onLike?.(feature.title, !liked);
//   };

//   const handleBookmark = (e) => {
//     e.stopPropagation();
//     setBookmarked(!bookmarked);
//     onBookmark?.(feature.title, !bookmarked);
//   };

//   const handleShare = (e) => {
//     e.stopPropagation();
//     onShare?.(feature.title);
//   };

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 60, scale: 0.9 }}
//       whileInView={{ opacity: 1, y: 0, scale: 1 }}
//       transition={{ duration: 0.8, delay: index * 0.15, type: "spring", stiffness: 100 }}
//       viewport={{ once: true }}
//       whileHover={{ y: -8 }}
//     >
//       <InteractiveFeatureCard 
//         ref={cardRef}
//         className="feature-card" 
//         elevation={0}
//         featured={feature.featured}
//         onClick={() => setExpanded(!expanded)}
//       >
//         {/* Hover overlay */}
//         <Box 
//           className="hover-overlay"
//           sx={{
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             background: `linear-gradient(135deg, ${alpha(feature.color, 0.02)}, ${alpha(feature.color, 0.05)})`,
//             opacity: 0,
//             transition: 'opacity 0.3s ease',
//             zIndex: 1,
//           }}
//         />
        
//         <CardContent sx={{ p: 4, height: '100%', display: 'flex', flexDirection: 'column', position: 'relative', zIndex: 2 }}>
//           <Box sx={{ mb: 'auto' }}>
//             {/* Header with badge and actions */}
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
//               <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//                 <Chip
//                   label={feature.badge}
//                   size="small"
//                   sx={{
//                     background: `linear-gradient(135deg, ${feature.color} 0%, ${alpha(feature.color, 0.8)} 100%)`,
//                     color: 'white',
//                     fontWeight: '600',
//                     fontSize: '0.75rem',
//                     height: '26px'
//                   }}
//                 />
//                 {feature.featured && (
//                   <Chip
//                     label="Popular"
//                     size="small"
//                     icon={<Star sx={{ fontSize: '12px !important' }} />}
//                     sx={{
//                       background: `linear-gradient(135deg, ${colors.warning} 0%, ${colors.warningLight} 100%)`,
//                       color: 'white',
//                       fontWeight: '600',
//                       fontSize: '0.75rem',
//                       height: '26px'
//                     }}
//                   />
//                 )}
//               </Box>
              
//               {/* Action buttons */}
//               <Box 
//                 className="card-actions"
//                 sx={{ 
//                   display: 'flex', 
//                   gap: 1, 
//                   opacity: 0,
//                   transform: 'translateY(-10px)',
//                   transition: 'all 0.3s ease'
//                 }}
//               >
//                 <Tooltip title="Like">
//                   <IconButton 
//                     size="small" 
//                     onClick={handleLike}
//                     sx={{ 
//                       color: liked ? colors.error : colors.textSecondary,
//                       '&:hover': { color: colors.error }
//                     }}
//                   >
//                     <Favorite sx={{ fontSize: 16 }} />
//                   </IconButton>
//                 </Tooltip>
//                 <Tooltip title="Bookmark">
//                   <IconButton 
//                     size="small" 
//                     onClick={handleBookmark}
//                     sx={{ 
//                       color: bookmarked ? colors.primary : colors.textSecondary,
//                       '&:hover': { color: colors.primary }
//                     }}
//                   >
//                     <BookmarkBorder sx={{ fontSize: 16 }} />
//                   </IconButton>
//                 </Tooltip>
//                 <Tooltip title="Share">
//                   <IconButton 
//                     size="small" 
//                     onClick={handleShare}
//                     sx={{ 
//                       color: colors.textSecondary,
//                       '&:hover': { color: colors.accent }
//                     }}
//                   >
//                     <Share sx={{ fontSize: 16 }} />
//                   </IconButton>
//                 </Tooltip>
//               </Box>
//             </Box>
            
//             <EnhancedIconContainer color={feature.color} animated={feature.featured}>
//               {feature.icon}
//             </EnhancedIconContainer>
            
//             <Typography 
//               variant="h5" 
//               component="h3" 
//               sx={{ 
//                 fontWeight: '700', 
//                 mb: 2,
//                 color: colors.textPrimary,
//                 fontSize: '1.3rem',
//                 lineHeight: 1.3
//               }}
//             >
//               {feature.title}
//             </Typography>
            
//             <Typography 
//               variant="body1" 
//               color={colors.textSecondary} 
//               sx={{ 
//                 mb: 3,
//                 lineHeight: 1.7,
//                 fontSize: '0.95rem'
//               }}
//             >
//               {feature.description}
//             </Typography>

//             {/* Progress indicator */}
//             <Box sx={{ mb: 3 }}>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//                 <Typography variant="caption" color={colors.textSecondary} sx={{ fontWeight: 500 }}>
//                   Feature Adoption
//                 </Typography>
//                 <Typography variant="caption" color={feature.color} sx={{ fontWeight: 600 }}>
//                   {feature.adoptionRate}%
//                 </Typography>
//               </Box>
//               <LinearProgress 
//                 variant="determinate" 
//                 value={feature.adoptionRate} 
//                 className="feature-progress"
//                 sx={{
//                   height: 6,
//                   borderRadius: 3,
//                   backgroundColor: alpha(feature.color, 0.1),
//                   '& .MuiLinearProgress-bar': {
//                     backgroundColor: feature.color,
//                     borderRadius: 3,
//                   },
//                   width: '60%',
//                   transition: 'width 0.6s ease'
//                 }}
//               />
//             </Box>

//             {/* Benefits list */}
//             <Box sx={{ mb: 3 }}>
//               {feature.benefits.slice(0, expanded ? feature.benefits.length : 2).map((benefit, idx) => (
//                 <motion.div
//                   key={idx}
//                   initial={{ opacity: 0, x: -20 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   transition={{ delay: idx * 0.1 }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
//                     <CheckCircle sx={{ fontSize: 16, color: feature.color, mr: 1.5, flexShrink: 0 }} />
//                     <Typography variant="body2" color={colors.textSecondary} sx={{ fontSize: '0.85rem' }}>
//                       {benefit}
//                     </Typography>
//                   </Box>
//                 </motion.div>
//               ))}
              
//               {feature.benefits.length > 2 && (
//                 <Button
//                   size="small"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     setExpanded(!expanded);
//                   }}
//                   sx={{
//                     color: feature.color,
//                     textTransform: 'none',
//                     fontSize: '0.8rem',
//                     p: 0,
//                     minWidth: 'auto',
//                     '&:hover': { backgroundColor: 'transparent' }
//                   }}
//                   endIcon={
//                     <motion.div
//                       animate={{ rotate: expanded ? 180 : 0 }}
//                       transition={{ duration: 0.3 }}
//                     >
//                       <ExpandMore sx={{ fontSize: 16 }} />
//                     </motion.div>
//                   }
//                 >
//                   {expanded ? 'Show less' : `+${feature.benefits.length - 2} more`}
//                 </Button>
//               )}
//             </Box>

//             <Divider sx={{ mb: 3 }} />
//           </Box>
          
//           <Box sx={{ mt: 'auto' }}>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//               <Typography 
//                 variant="body2" 
//                 sx={{ 
//                   color: feature.color,
//                   fontWeight: '600',
//                   fontSize: '0.85rem'
//                 }}
//               >
//                 {feature.stats}
//               </Typography>
//               <Chip
//                 label={feature.category}
//                 size="small"
//                 variant="outlined"
//                 sx={{
//                   borderColor: alpha(feature.color, 0.3),
//                   color: feature.color,
//                   fontSize: '0.7rem',
//                   height: '22px'
//                 }}
//               />
//             </Box>
            
//             <InteractiveButton 
//               variant="contained"
//               endIcon={<ArrowForward />}
//               fullWidth
//               sx={{
//                 background: `linear-gradient(135deg, ${feature.color} 0%, ${alpha(feature.color, 0.8)} 100%)`,
//                 '&:hover': {
//                   background: `linear-gradient(135deg, ${alpha(feature.color, 0.9)} 0%, ${alpha(feature.color, 0.7)} 100%)`,
//                   boxShadow: `0 12px 32px ${alpha(feature.color, 0.35)}`
//                 }
//               }}
//             >
//               Explore Feature
//             </InteractiveButton>
//           </Box>
//         </CardContent>
//       </InteractiveFeatureCard>
//     </motion.div>
//   );
// };

// const HomeContent = () => {
//   const [activeSection, setActiveSection] = useState('features');

//   // Enhanced features data with more comprehensive information
//   const features = [
//     {
//       icon: <Assignment fontSize="large" />,
//       title: 'Smart Assignment Hub',
//       description: 'Intelligent assignment management with AI-powered prioritization, deadline tracking, and automated reminders.',
//       badge: 'Core',
//       color: colors.primary,
//       featured: true,
//       adoptionRate: 92,
//       stats: '2.5K+ submissions',
//       category: 'Productivity',
//       benefits: [
//         'AI-powered deadline optimization',
//         'Smart priority scoring',
//         'Collaborative assignment sharing',
//         'Progress analytics & insights',
//         'Integration with calendar systems'
//       ]
//     },
//     {
//       icon: <Quiz fontSize="large" />,
//       title: 'Interactive Quizzes',
//       description: 'Dynamic quiz creation with adaptive difficulty, real-time feedback, and comprehensive analytics.',
//       badge: 'Popular',
//       color: colors.success,
//       featured: false,
//       adoptionRate: 87,
//       stats: '15K+ attempts',
//       category: 'Assessment',
//       benefits: [
//         'Adaptive difficulty adjustment',
//         'Instant feedback & explanations',
//         'Performance trend analysis',
//         'Custom question banks'
//       ]
//     },
//     {
//       icon: <Chat fontSize="large" />,
//       title: 'Study Groups',
//       description: 'Create and join study groups with video calls, shared whiteboards, and collaborative note-taking.',
//       badge: 'Social',
//       color: colors.accent,
//       featured: true,
//       adoptionRate: 78,
//       stats: '800+ groups',
//       category: 'Collaboration',
//       benefits: [
//         'HD video conferencing',
//         'Real-time collaboration tools',
//         'Shared resource libraries',
//         'Group progress tracking',
//         'Peer mentorship matching'
//       ]
//     },
//     {
//       icon: <Announcement fontSize="large" />,
//       title: 'Smart Announcements',
//       description: 'AI-curated announcements with personalized relevance scoring and multi-channel delivery.',
//       badge: 'New',
//       color: colors.warning,
//       featured: false,
//       adoptionRate: 65,
//       stats: '1.2K+ delivered',
//       category: 'Communication',
//       benefits: [
//         'Personalized content filtering',
//         'Multi-channel notifications',
//         'Read receipt tracking',
//         'Emergency alert system'
//       ]
//     },
//     {
//       icon: <CalendarToday fontSize="large" />,
//       title: 'Schedule Optimizer',
//       description: 'AI-driven schedule optimization with conflict resolution, time blocking, and productivity insights.',
//       badge: 'Premium',
//       color: colors.purple,
//       featured: false,
//       adoptionRate: 73,
//       stats: '5.8K+ schedules',
//       category: 'Planning',
//       benefits: [
//         'Automatic conflict detection',
//         'Smart time allocation',
//         'Productivity pattern analysis',
//         'Integration with external calendars'
//       ]
//     },
//     {
//       icon: <Psychology fontSize="large" />,
//       title: 'AI Learning Assistant',
//       description: 'Personalized AI tutor providing 24/7 academic support, concept explanations, and study strategies.',
//       badge: 'AI-Powered',
//       color: colors.pink,
//       featured: true,
//       adoptionRate: 89,
//       stats: '50K+ queries',
//       category: 'AI Support',
//       benefits: [
//         '24/7 availability',
//         'Multi-subject expertise',
//         'Personalized learning paths',
//         'Interactive problem solving',
//         'Progress adaptation'
//       ]
//     }
//   ];

//   const platformStats = [
//     {
//       icon: <School className="stats-icon" />,
//       number: '25,000+',
//       label: 'Active Students',
//       color: colors.primary,
//       gradient: `linear-gradient(135deg, ${alpha(colors.primary, 0.1)} 0%, ${alpha(colors.primary, 0.05)} 100%)`
//     },
//     {
//       icon: <TrendingUp className="stats-icon" />,
//       number: '98%',
//       label: 'Success Rate',
//       color: colors.success,
//       gradient: `linear-gradient(135deg, ${alpha(colors.success, 0.1)} 0%, ${alpha(colors.success, 0.05)} 100%)`
//     },
//     {
//       icon: <Speed className="stats-icon" />,
//       number: '45%',
//       label: 'Faster Learning',
//       color: colors.warning,
//       gradient: `linear-gradient(135deg, ${alpha(colors.warning, 0.1)} 0%, ${alpha(colors.warning, 0.05)} 100%)`
//     },
//     {
//       icon: <Security className="stats-icon" />,
//       number: '99.9%',
//       label: 'Uptime',
//       color: colors.accent,
//       gradient: `linear-gradient(135deg, ${alpha(colors.accent, 0.1)} 0%, ${alpha(colors.accent, 0.05)} 100%)`
//     }
//   ];

//   const handleFeatureAction = (action, title, value) => {
//     console.log(`${action}:`, title, value);
//   };

//   return (
//     <Box sx={{ py: 12, position: 'relative', overflow: 'hidden' }}>
//       {/* Background decorative elements */}
//       <Box
//         sx={{
//           position: 'absolute',
//           top: '10%',
//           right: '5%',
//           width: 300,
//           height: 300,
//           background: `radial-gradient(circle, ${alpha(colors.primary, 0.04)} 0%, transparent 70%)`,
//           borderRadius: '50%',
//           animation: `${gentleFloat} 20s ease-in-out infinite`,
//           zIndex: 0,
//         }}
//       />
//       <Box
//         sx={{
//           position: 'absolute',
//           bottom: '20%',
//           left: '8%',
//           width: 200,
//           height: 200,
//           background: `radial-gradient(circle, ${alpha(colors.accent, 0.04)} 0%, transparent 70%)`,
//           borderRadius: '50%',
//           animation: `${gentleFloat} 15s ease-in-out infinite reverse`,
//           zIndex: 0,
//         }}
//       />

//       <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
//         {/* Section Header */}
//         <motion.div
//           initial={{ opacity: 0, y: 40 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           viewport={{ once: true }}
//         >
//           <Box sx={{ textAlign: 'center', mb: 8 }}>
//             <Chip
//               icon={<AutoAwesome />}
//               label="Platform Features"
//               sx={{
//                 mb: 3,
//                 background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`,
//                 color: 'white',
//                 fontSize: '1rem',
//                 fontWeight: '600',
//                 py: 1,
//                 px: 3,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: '900',
//                 color: colors.textPrimary,
//                 mb: 3,
//                 fontSize: { xs: '2.5rem', md: '3.5rem' },
//                 background: `linear-gradient(135deg, ${colors.textPrimary} 0%, ${colors.primary} 100%)`,
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//               }}
//             >
//               Everything You Need to{' '}
//               <Box
//                 component="span"
//                 sx={{
//                   background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`,
//                   WebkitBackgroundClip: 'text',
//                   WebkitTextFillColor: 'transparent',
//                 }}
//               >
//                 Succeed
//               </Box>
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 color: colors.textSecondary,
//                 maxWidth: 800,
//                 mx: 'auto',
//                 fontSize: '1.2rem',
//                 lineHeight: 1.6,
//               }}
//             >
//               Discover our comprehensive suite of tools designed to revolutionize your academic journey. 
//               From AI-powered learning to collaborative study sessions, we've got you covered.
//             </Typography>
//           </Box>
//         </motion.div>

//         {/* Enhanced Features Grid */}
//         <Grid container spacing={4} sx={{ mb: 12 }}>
//           {features.map((feature, index) => (
//             <Grid item xs={12} md={6} lg={4} key={index}>
//               <SuperFeatureCard
//                 feature={feature}
//                 index={index}
//                 onLike={(title, liked) => handleFeatureAction('like', title, liked)}
//                 onBookmark={(title, bookmarked) => handleFeatureAction('bookmark', title, bookmarked)}
//                 onShare={(title) => handleFeatureAction('share', title)}
//               />
//             </Grid>
//           ))}
//         </Grid>

//         {/* Platform Statistics */}
//         <motion.div
//           initial={{ opacity: 0, y: 60 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1, delay: 0.2 }}
//           viewport={{ once: true }}
//         >
//           <Box sx={{ textAlign: 'center', mb: 6 }}>
//             <Typography
//               variant="h3"
//               sx={{
//                 fontWeight: '800',
//                 color: colors.textPrimary,
//                 mb: 2,
//                 fontSize: { xs: '2rem', md: '2.8rem' },
//               }}
//             >
//               Trusted by Students Worldwide
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 color: colors.textSecondary,
//                 maxWidth: 600,
//                 mx: 'auto',
//               }}
//             >
//               Join a thriving community of learners achieving academic excellence
//             </Typography>
//           </Box>

//           <Grid container spacing={4} sx={{ mb: 12 }}>
//             {platformStats.map((stat, index) => (
//               <Grid item xs={6} md={3} key={index}>
//                 <motion.div
//                   initial={{ opacity: 0, scale: 0.8 }}
//                   whileInView={{ opacity: 1, scale: 1 }}
//                   transition={{ duration: 0.6, delay: index * 0.1 }}
//                   viewport={{ once: true }}
//                 >
//                   <StatsCard elevation={0} gradient={stat.gradient}>
//                     <EnhancedIconContainer color={stat.color} sx={{ mx: 'auto', mb: 2 }}>
//                       {stat.icon}
//                     </EnhancedIconContainer>
//                     <Typography
//                       variant="h3"
//                       sx={{
//                         fontWeight: '900',
//                         color: stat.color,
//                         mb: 1,
//                         fontSize: { xs: '2rem', md: '2.5rem' },
//                       }}
//                     >
//                       {stat.number}
//                     </Typography>
//                     <Typography
//                       variant="h6"
//                       sx={{
//                         color: colors.textSecondary,
//                         fontWeight: '600',
//                       }}
//                     >
//                       {stat.label}
//                     </Typography>
//                   </StatsCard>
//                 </motion.div>
//               </Grid>
//             ))}
//           </Grid>
//         </motion.div>

//         {/* Why Choose Us Section */}
//         <motion.div
//           initial={{ opacity: 0, y: 60 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1 }}
//           viewport={{ once: true }}
//         >
//           <Grid container spacing={8} alignItems="center" sx={{ mb: 12 }}>
//             <Grid item xs={12} md={6}>
//               <Box>
//                 <Chip
//                   icon={<Lightbulb />}
//                   label="Why Choose SSPACE"
//                   sx={{
//                     mb: 3,
//                     background: `linear-gradient(135deg, ${colors.success} 0%, ${colors.successLight} 100%)`,
//                     color: 'white',
//                     fontSize: '0.9rem',
//                     fontWeight: '600',
//                   }}
//                 />
//                 <Typography
//                   variant="h3"
//                   sx={{
//                     fontWeight: '800',
//                     color: colors.textPrimary,
//                     mb: 3,
//                     fontSize: { xs: '2.2rem', md: '3rem' },
//                     lineHeight: 1.2,
//                   }}
//                 >
//                   The Future of
//                   <Box
//                     component="span"
//                     sx={{
//                       background: `linear-gradient(135deg, ${colors.success} 0%, ${colors.successLight} 100%)`,
//                       WebkitBackgroundClip: 'text',
//                       WebkitTextFillColor: 'transparent',
//                     }}
//                   >
//                     {' '}Academic Excellence
//                   </Box>
//                 </Typography>
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     color: colors.textSecondary,
//                     mb: 4,
//                     lineHeight: 1.6,
//                   }}
//                 >
//                   Experience a revolutionary approach to learning that adapts to your unique style, 
//                   connects you with peers, and accelerates your academic growth through cutting-edge technology.
//                 </Typography>

//                 {/* Feature highlights */}
//                 <Grid container spacing={3} sx={{ mb: 4 }}>
//                   {[
//                     { icon: <Analytics />, title: 'AI-Powered Analytics', desc: 'Smart insights into your learning patterns' },
//                     { icon: <CloudSync />, title: 'Cloud Synchronization', desc: 'Access your data anywhere, anytime' },
//                     { icon: <MobileFriendly />, title: 'Mobile Optimized', desc: 'Perfect experience on all devices' },
//                     { icon: <LiveHelp />, title: '24/7 Support', desc: 'Get help whenever you need it' }
//                   ].map((item, idx) => (
//                     <Grid item xs={12} sm={6} key={idx}>
//                       <motion.div
//                         initial={{ opacity: 0, x: -20 }}
//                         whileInView={{ opacity: 1, x: 0 }}
//                         transition={{ duration: 0.6, delay: idx * 0.1 }}
//                         viewport={{ once: true }}
//                       >
//                         <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
//                           <Avatar
//                             sx={{
//                               width: 40,
//                               height: 40,
//                               background: `linear-gradient(135deg, ${colors.success} 0%, ${colors.successLight} 100%)`,
//                               mt: 0.5,
//                             }}
//                           >
//                             {React.cloneElement(item.icon, { sx: { fontSize: 20 } })}
//                           </Avatar>
//                           <Box>
//                             <Typography
//                               variant="subtitle1"
//                               sx={{
//                                 fontWeight: '700',
//                                 color: colors.textPrimary,
//                                 mb: 0.5,
//                               }}
//                             >
//                               {item.title}
//                             </Typography>
//                             <Typography
//                               variant="body2"
//                               sx={{
//                                 color: colors.textSecondary,
//                                 fontSize: '0.9rem',
//                               }}
//                             >
//                               {item.desc}
//                             </Typography>
//                           </Box>
//                         </Box>
//                       </motion.div>
//                     </Grid>
//                   ))}
//                 </Grid>

//                 <InteractiveButton
//                   variant="contained"
//                   size="large"
//                   endIcon={<ChevronRight />}
//                   sx={{
//                     background: `linear-gradient(135deg, ${colors.success} 0%, ${colors.successLight} 100%)`,
//                     px: 4,
//                     py: 1.5,
//                     fontSize: '1.1rem',
//                     fontWeight: '700',
//                     '&:hover': {
//                       background: `linear-gradient(135deg, ${alpha(colors.success, 0.9)} 0%, ${alpha(colors.successLight, 0.9)} 100%)`,
//                       boxShadow: `0 12px 32px ${alpha(colors.success, 0.35)}`
//                     }
//                   }}
//                 >
//                   Learn More
//                 </InteractiveButton>
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <motion.div
//                 animate={{ 
//                   y: [0, -10, 0],
//                 }}
//                 transition={{
//                   repeat: Infinity,
//                   duration: 4,
//                   ease: "easeInOut"
//                 }}
//               >
//                 <Box
//                   sx={{
//                     position: 'relative',
//                     background: `linear-gradient(135deg, ${alpha(colors.success, 0.1)} 0%, ${alpha(colors.successLight, 0.1)} 100%)`,
//                     borderRadius: '32px',
//                     p: 4,
//                     border: `1px solid ${alpha(colors.success, 0.2)}`,
//                     boxShadow: `0 20px 60px ${alpha(colors.success, 0.15)}`,
//                     backdropFilter: 'blur(20px)',
//                   }}
//                 >
//                   {/* Decorative elements */}
//                   <Box
//                     sx={{
//                       position: 'absolute',
//                       top: 20,
//                       right: 20,
//                       width: 60,
//                       height: 60,
//                       background: `linear-gradient(135deg, ${colors.success} 0%, ${colors.successLight} 100%)`,
//                       borderRadius: '16px',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       animation: `${breathe} 4s ease-in-out infinite`,
//                     }}
//                   >
//                     <RocketLaunch sx={{ color: 'white', fontSize: 28 }} />
//                   </Box>

//                   {/* Mock interface elements */}
//                   <Box sx={{ mt: 8 }}>
//                     {[1, 2, 3].map((item) => (
//                       <motion.div
//                         key={item}
//                         initial={{ opacity: 0, x: 20 }}
//                         whileInView={{ opacity: 1, x: 0 }}
//                         transition={{ duration: 0.6, delay: item * 0.2 }}
//                         viewport={{ once: true }}
//                       >
//                         <Box
//                           sx={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: 2,
//                             p: 2,
//                             mb: 2,
//                             background: colors.card,
//                             borderRadius: '16px',
//                             border: `1px solid ${colors.border}`,
//                             boxShadow: `0 4px 20px ${colors.shadow}`,
//                           }}
//                         >
//                           <Avatar
//                             sx={{
//                               width: 36,
//                               height: 36,
//                               background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryLight} 100%)`,
//                             }}
//                           >
//                             <CheckCircle sx={{ fontSize: 18, color: 'white' }} />
//                           </Avatar>
//                           <Box sx={{ flex: 1 }}>
//                             <Typography
//                               variant="subtitle2"
//                               sx={{ fontWeight: '600', color: colors.textPrimary, mb: 0.5 }}
//                             >
//                               Feature {item} Completed
//                             </Typography>
//                             <LinearProgress
//                               variant="determinate"
//                               value={100}
//                               sx={{
//                                 height: 6,
//                                 borderRadius: 3,
//                                 backgroundColor: alpha(colors.success, 0.1),
//                                 '& .MuiLinearProgress-bar': {
//                                   backgroundColor: colors.success,
//                                   borderRadius: 3,
//                                 }
//                               }}
//                             />
//                           </Box>
//                         </Box>
//                       </motion.div>
//                     ))}
//                   </Box>
//                 </Box>
//               </motion.div>
//             </Grid>
//           </Grid>
//         </motion.div>

//         {/* Call to Action Section */}
//         <motion.div
//           initial={{ opacity: 0, scale: 0.95 }}
//           whileInView={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 1 }}
//           viewport={{ once: true }}
//         >
//           <GradientCTASection>
//             <Container maxWidth="md" sx={{ position: 'relative', zIndex: 2 }}>
//               <Typography
//                 variant="h2"
//                 sx={{
//                   fontWeight: '900',
//                   mb: 3,
//                   fontSize: { xs: '2.5rem', md: '3.5rem' },
//                   textShadow: '0 4px 20px rgba(0,0,0,0.3)',
//                 }}
//               >
//                 Ready to Transform Your
//                 <br />
//                 Academic Journey?
//               </Typography>
              
//               <Typography
//                 variant="h6"
//                 sx={{
//                   mb: 5,
//                   opacity: 0.95,
//                   fontSize: '1.3rem',
//                   lineHeight: 1.6,
//                   textShadow: '0 2px 10px rgba(0,0,0,0.2)',
//                 }}
//               >
//                 Join thousands of students who have already discovered the power of intelligent learning. 
//                 Start your journey towards academic excellence today with our comprehensive platform.
//               </Typography>
              
//               <Box
//                 sx={{
//                   display: 'flex',
//                   gap: 3,
//                   justifyContent: 'center',
//                   flexDirection: { xs: 'column', sm: 'row' },
//                   mb: 4,
//                 }}
//               >
//                 <motion.div
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                 >
//                   <InteractiveButton
//                     variant="contained"
//                     size="large"
//                     endIcon={<RocketLaunch />}
//                     sx={{
//                       px: 5,
//                       py: 2,
//                       fontSize: '1.2rem',
//                       fontWeight: '700',
//                       background: alpha('#ffffff', 0.2),
//                       color: 'white',
//                       border: `2px solid ${alpha('#ffffff', 0.3)}`,
//                       backdropFilter: 'blur(10px)',
//                       '&:hover': {
//                         background: alpha('#ffffff', 0.3),
//                         transform: 'translateY(-3px)',
//                         boxShadow: `0 20px 50px ${alpha('#000000', 0.3)}`,
//                       },
//                     }}
//                   >
//                     Get Started Free
//                   </InteractiveButton>
//                 </motion.div>
                
//                 <motion.div
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                 >
//                   <InteractiveButton
//                     variant="outlined"
//                     size="large"
//                     startIcon={<PlayArrow />}
//                     sx={{
//                       px: 5,
//                       py: 2,
//                       fontSize: '1.2rem',
//                       fontWeight: '700',
//                       color: 'white',
//                       borderColor: alpha('#ffffff', 0.5),
//                       borderWidth: 2,
//                       '&:hover': {
//                         borderWidth: 2,
//                         borderColor: '#ffffff',
//                         background: alpha('#ffffff', 0.1),
//                         backdropFilter: 'blur(10px)',
//                       },
//                     }}
//                   >
//                     Watch Demo
//                   </InteractiveButton>
//                 </motion.div>
//               </Box>
              
//               <Typography
//                 variant="body1"
//                 sx={{
//                   opacity: 0.8,
//                   fontSize: '1rem',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   gap: 1,
//                   flexWrap: 'wrap',
//                 }}
//               >
//                 <CheckCircle sx={{ fontSize: 18 }} />
//                 No credit card required • Free forever • Premium features available
//               </Typography>
//             </Container>
//           </GradientCTASection>
//         </motion.div>
//       </Container>
//     </Box>
//   );
// };

// export default HomeContent;


import React, { useEffect, useRef, useState } from 'react';
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  alpha,
  useTheme,
  Chip,
  Avatar,
  Divider,
  Paper,
  LinearProgress,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  Assignment,
  Quiz,
  Work,
  RocketLaunch,
  School,
  TrendingUp,
  SupportAgent,
  AutoAwesome,
  Star,
  ArrowForward,
  CheckCircle,
  Psychology,
  Speed,
  Security,
  PlayArrow,
  Lightbulb,
  Groups,
  CloudSync,
  MobileFriendly,
  LiveHelp,
  BookmarkBorder,
  Favorite,
  Share,
  ExpandMore,
  ChevronRight
} from '@mui/icons-material';
import { motion, AnimatePresence } from 'framer-motion';
import { styled, keyframes } from '@mui/material/styles';

// Enhanced animations matching Home component style
const gentleFloat = keyframes`
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-8px) rotate(1deg); }
`;

const subtleShimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const breathe = keyframes`
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.03); opacity: 0.95; }
`;

const slideInGradient = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const ripple = keyframes`
  0% { transform: scale(0); opacity: 1; }
  100% { transform: scale(4); opacity: 0; }
`;

const glowPulse = keyframes`
  0%, 100% { box-shadow: 0 0 20px rgba(30, 64, 175, 0.2); }
  50% { box-shadow: 0 0 30px rgba(30, 64, 175, 0.4), 0 0 40px rgba(30, 64, 175, 0.2); }
`;

// Enhanced color palette matching Home component
const colors = {
  primary: '#1e40af',
  primaryLight: '#3b82f6',
  primaryDark: '#1e3a8a',
  secondary: '#374151',
  accent: '#0284c7',
  accentLight: '#0ea5e9',
  success: '#059669',
  successLight: '#10b981',
  warning: '#d97706',
  warningLight: '#f59e0b',
  error: '#dc2626',
  errorLight: '#ef4444',
  purple: '#7c3aed',
  purpleLight: '#8b5cf6',
  pink: '#db2777',
  pinkLight: '#ec4899',
  background: '#f8fafc',
  backgroundAlt: '#f1f5f9',
  card: '#ffffff',
  surface: '#f9fafb',
  textPrimary: '#111827',
  textSecondary: '#6b7280',
  border: '#e5e7eb',
  borderLight: '#f3f4f6',
  shadow: 'rgba(0, 0, 0, 0.04)',
  shadowHover: 'rgba(0, 0, 0, 0.12)',
  overlay: 'rgba(255, 255, 255, 0.8)'
};

// Enhanced styled components matching Home component
const InteractiveFeatureCard = styled(Card)(({ theme, featured }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  background: featured 
    ? `linear-gradient(135deg, ${alpha(colors.primary, 0.02)} 0%, ${alpha(colors.accent, 0.02)} 100%)`
    : colors.card,
  borderRadius: '24px',
  border: featured 
    ? `2px solid ${alpha(colors.primary, 0.1)}`
    : `1px solid ${colors.border}`,
  boxShadow: featured
    ? `0 8px 40px ${alpha(colors.primary, 0.12)}`
    : `0 4px 24px ${colors.shadow}`,
  transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
  position: 'relative',
  overflow: 'hidden',
  cursor: 'pointer',
  '&:hover': {
    transform: 'translateY(-16px) scale(1.02)',
    boxShadow: `0 25px 80px ${colors.shadowHover}`,
    '& .card-actions': {
      opacity: 1,
      transform: 'translateY(0)',
    },
    '& .feature-progress': {
      width: '100%',
    },
    '& .hover-overlay': {
      opacity: 1,
    }
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: featured ? '4px' : '2px',
    background: featured
      ? `linear-gradient(90deg, ${colors.primary}, ${colors.accent}, ${colors.primary})`
      : `linear-gradient(90deg, transparent, ${colors.primary}, transparent)`,
    backgroundSize: '200% 100%',
    animation: `${subtleShimmer} 3s ease-in-out infinite`,
    opacity: 0,
    transition: 'opacity 0.3s ease',
  },
  '&:hover::before': {
    opacity: 1,
  }
}));

const EnhancedIconContainer = styled(Box)(({ color, animated }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 80,
  height: 80,
  borderRadius: '24px',
  background: `linear-gradient(135deg, ${color} 0%, ${alpha(color, 0.8)} 100%)`,
  color: 'white',
  marginBottom: '24px',
  boxShadow: `0 16px 40px ${alpha(color, 0.25)}`,
  position: 'relative',
  overflow: 'hidden',
  animation: animated ? `${glowPulse} 3s ease-in-out infinite` : 'none',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    left: '-50%',
    width: '200%',
    height: '200%',
    background: 'linear-gradient(45deg, transparent, rgba(255,255,255,0.15), transparent)',
    transform: 'rotate(45deg)',
    transition: 'all 0.6s ease',
    opacity: 0,
  },
  '&:hover::before': {
    opacity: 1,
    animation: 'shine 1.5s ease-in-out',
  },
  '@keyframes shine': {
    '0%': { transform: 'rotate(45deg) translate(-100%, -100%)' },
    '100%': { transform: 'rotate(45deg) translate(100%, 100%)' },
  }
}));

const StatsCard = styled(Paper)(({ theme, gradient }) => ({
  textAlign: 'center',
  padding: '40px 32px',
  background: gradient || colors.card,
  borderRadius: '24px',
  border: `1px solid ${colors.border}`,
  boxShadow: `0 8px 32px ${colors.shadow}`,
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    transform: 'translateY(-12px)',
    boxShadow: `0 20px 60px ${colors.shadowHover}`,
    '& .stats-icon': {
      transform: 'scale(1.1) rotate(5deg)',
    }
  },
}));

const GradientCTASection = styled(Box)({
  textAlign: 'center',
  padding: '100px 80px',
  background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryLight} 30%, ${colors.accent} 70%, ${colors.accentLight} 100%)`,
  backgroundSize: '300% 300%',
  animation: `${slideInGradient} 8s ease infinite`,
  borderRadius: '40px',
  color: 'white',
  boxShadow: `0 30px 100px ${alpha(colors.primary, 0.3)}`,
  position: 'relative',
  overflow: 'hidden',
  border: `1px solid ${alpha('#ffffff', 0.15)}`,
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="30" cy="30" r="1"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
  },
});

const InteractiveButton = styled(Button)(({ variant: buttonVariant, color }) => ({
  borderRadius: '16px',
  padding: '12px 32px',
  fontSize: '1.1rem',
  fontWeight: '600',
  textTransform: 'none',
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: 0,
    height: 0,
    backgroundColor: alpha('#ffffff', 0.2),
    borderRadius: '50%',
    transform: 'translate(-50%, -50%)',
    transition: 'width 0.6s, height 0.6s',
  },
  '&:active::before': {
    width: '300px',
    height: '300px',
  },
  '&:hover': {
    transform: 'translateY(-2px)',
  }
}));

// Enhanced feature card component with more interactivity
const SuperFeatureCard = ({ feature, index, onLike, onBookmark, onShare }) => {
  const [liked, setLiked] = useState(false);
  const [bookmarked, setBookmarked] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const cardRef = useRef(null);

  const handleLike = (e) => {
    e.stopPropagation();
    setLiked(!liked);
    onLike?.(feature.title, !liked);
  };

  const handleBookmark = (e) => {
    e.stopPropagation();
    setBookmarked(!bookmarked);
    onBookmark?.(feature.title, !bookmarked);
  };

  const handleShare = (e) => {
    e.stopPropagation();
    onShare?.(feature.title);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 60, scale: 0.9 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.8, delay: index * 0.15, type: "spring", stiffness: 100 }}
      viewport={{ once: true }}
      whileHover={{ y: -8 }}
    >
      <InteractiveFeatureCard 
        ref={cardRef}
        className="feature-card" 
        elevation={0}
        featured={feature.featured}
        onClick={() => setExpanded(!expanded)}
      >
        {/* Hover overlay */}
        <Box 
          className="hover-overlay"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `linear-gradient(135deg, ${alpha(feature.color, 0.02)}, ${alpha(feature.color, 0.05)})`,
            opacity: 0,
            transition: 'opacity 0.3s ease',
            zIndex: 1,
          }}
        />
        
        <CardContent sx={{ p: 4, height: '100%', display: 'flex', flexDirection: 'column', position: 'relative', zIndex: 2 }}>
          <Box sx={{ mb: 'auto' }}>
            {/* Header with badge and actions */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                <Chip
                  label={feature.badge}
                  size="small"
                  sx={{
                    background: `linear-gradient(135deg, ${feature.color} 0%, ${alpha(feature.color, 0.8)} 100%)`,
                    color: 'white',
                    fontWeight: '600',
                    fontSize: '0.75rem',
                    height: '26px'
                  }}
                />
                {feature.featured && (
                  <Chip
                    label="Popular"
                    size="small"
                    icon={<Star sx={{ fontSize: '12px !important' }} />}
                    sx={{
                      background: `linear-gradient(135deg, ${colors.warning} 0%, ${colors.warningLight} 100%)`,
                      color: 'white',
                      fontWeight: '600',
                      fontSize: '0.75rem',
                      height: '26px'
                    }}
                  />
                )}
              </Box>
              
              {/* Action buttons */}
              <Box 
                className="card-actions"
                sx={{ 
                  display: 'flex', 
                  gap: 1, 
                  opacity: 0,
                  transform: 'translateY(-10px)',
                  transition: 'all 0.3s ease'
                }}
              >
                <Tooltip title="Like">
                  <IconButton 
                    size="small" 
                    onClick={handleLike}
                    sx={{ 
                      color: liked ? colors.error : colors.textSecondary,
                      '&:hover': { color: colors.error }
                    }}
                  >
                    <Favorite sx={{ fontSize: 16 }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Bookmark">
                  <IconButton 
                    size="small" 
                    onClick={handleBookmark}
                    sx={{ 
                      color: bookmarked ? colors.primary : colors.textSecondary,
                      '&:hover': { color: colors.primary }
                    }}
                  >
                    <BookmarkBorder sx={{ fontSize: 16 }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Share">
                  <IconButton 
                    size="small" 
                    onClick={handleShare}
                    sx={{ 
                      color: colors.textSecondary,
                      '&:hover': { color: colors.accent }
                    }}
                  >
                    <Share sx={{ fontSize: 16 }} />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
            
            <EnhancedIconContainer color={feature.color} animated={feature.featured}>
              {feature.icon}
            </EnhancedIconContainer>
            
            <Typography 
              variant="h5" 
              component="h3" 
              sx={{ 
                fontWeight: '700', 
                mb: 2,
                color: colors.textPrimary,
                fontSize: '1.3rem',
                lineHeight: 1.3
              }}
            >
              {feature.title}
            </Typography>
            
            <Typography 
              variant="body1" 
              color={colors.textSecondary} 
              sx={{ 
                mb: 3,
                lineHeight: 1.7,
                fontSize: '0.95rem'
              }}
            >
              {feature.description}
            </Typography>

            {/* Progress indicator */}
            <Box sx={{ mb: 3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="caption" color={colors.textSecondary} sx={{ fontWeight: 500 }}>
                  Feature Adoption
                </Typography>
                <Typography variant="caption" color={feature.color} sx={{ fontWeight: 600 }}>
                  {feature.adoptionRate}%
                </Typography>
              </Box>
              <LinearProgress 
                variant="determinate" 
                value={feature.adoptionRate} 
                className="feature-progress"
                sx={{
                  height: 6,
                  borderRadius: 3,
                  backgroundColor: alpha(feature.color, 0.1),
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: feature.color,
                    borderRadius: 3,
                  },
                  width: '60%',
                  transition: 'width 0.6s ease'
                }}
              />
            </Box>

            {/* Benefits list */}
            <Box sx={{ mb: 3 }}>
              {feature.benefits.slice(0, expanded ? feature.benefits.length : 2).map((benefit, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: idx * 0.1 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                    <CheckCircle sx={{ fontSize: 16, color: feature.color, mr: 1.5, flexShrink: 0 }} />
                    <Typography variant="body2" color={colors.textSecondary} sx={{ fontSize: '0.85rem' }}>
                      {benefit}
                    </Typography>
                  </Box>
                </motion.div>
              ))}
              
              {feature.benefits.length > 2 && (
                <Button
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setExpanded(!expanded);
                  }}
                  sx={{
                    color: feature.color,
                    textTransform: 'none',
                    fontSize: '0.8rem',
                    p: 0,
                    minWidth: 'auto',
                    '&:hover': { backgroundColor: 'transparent' }
                  }}
                  endIcon={
                    <motion.div
                      animate={{ rotate: expanded ? 180 : 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <ExpandMore sx={{ fontSize: 16 }} />
                    </motion.div>
                  }
                >
                  {expanded ? 'Show less' : `+${feature.benefits.length - 2} more`}
                </Button>
              )}
            </Box>

            <Divider sx={{ mb: 3 }} />
          </Box>
          
          <Box sx={{ mt: 'auto' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: feature.color,
                  fontWeight: '600',
                  fontSize: '0.85rem'
                }}
              >
                {feature.stats}
              </Typography>
              <Chip
                label={feature.category}
                size="small"
                variant="outlined"
                sx={{
                  borderColor: alpha(feature.color, 0.3),
                  color: feature.color,
                  fontSize: '0.7rem',
                  height: '22px'
                }}
              />
            </Box>
            
            <InteractiveButton 
              variant="contained"
              endIcon={<ArrowForward />}
              fullWidth
              sx={{
                background: `linear-gradient(135deg, ${feature.color} 0%, ${alpha(feature.color, 0.8)} 100%)`,
                '&:hover': {
                  background: `linear-gradient(135deg, ${alpha(feature.color, 0.9)} 0%, ${alpha(feature.color, 0.7)} 100%)`,
                  boxShadow: `0 12px 32px ${alpha(feature.color, 0.35)}`
                }
              }}
            >
              Explore Feature
            </InteractiveButton>
          </Box>
        </CardContent>
      </InteractiveFeatureCard>
    </motion.div>
  );
};

const HomeContent = () => {
  const [activeSection, setActiveSection] = useState('features');

  // Enhanced features data with more comprehensive information
  const features = [
    {
      icon: <Assignment fontSize="large" />,
      title: 'Smart Assignment Hub',
      description: 'Comprehensive assignment management with priority tracking, deadline organization, and progress monitoring.',
      badge: 'Core',
      color: colors.primary,
      featured: true,
      adoptionRate: 92,
      stats: '2.5K+ submissions',
      category: 'Productivity',
      benefits: [
        'Priority-based task organization',
        'Deadline tracking and alerts',
        'Collaborative assignment sharing',
        'Progress analytics & insights',
        'Integration with calendar systems'
      ]
    },
    {
      icon: <Quiz fontSize="large" />,
      title: 'Interactive Quizzes',
      description: 'Dynamic quiz creation with adaptive difficulty, real-time feedback, and comprehensive analytics.',
      badge: 'Popular',
      color: colors.success,
      featured: false,
      adoptionRate: 87,
      stats: '15K+ attempts',
      category: 'Assessment',
      benefits: [
        'Adaptive difficulty adjustment',
        'Instant feedback & explanations',
        'Performance trend analysis',
        'Custom question banks'
      ]
    },
    {
      icon: <Psychology fontSize="large" />,
      title: 'Chatbot Assistant',
      description: 'Personalized chatbot providing 24/7 academic support, concept explanations, and study strategies.',
      badge: 'Support',
      color: colors.pink,
      featured: true,
      adoptionRate: 89,
      stats: '50K+ queries',
      category: 'Support',
      benefits: [
        '24/7 availability',
        'Multi-subject expertise',
        'Personalized learning paths',
        'Interactive problem solving',
        'Progress adaptation'
      ]
    },
    // {
    //   icon: <Work fontSize="large" />,
    //   title: 'Project Management',
    //   description: 'Comprehensive project tracking with milestone management, team collaboration, and deadline monitoring.',
    //   badge: 'Organization',
    //   color: colors.purple,
    //   featured: false,
    //   adoptionRate: 75,
    //   stats: '3.2K+ projects',
    //   category: 'Management',
    //   benefits: [
    //     'Milestone tracking',
    //     'Team collaboration tools',
    //     'Resource allocation',
    //     'Timeline visualization'
    //   ]
    // }
  ];

  const platformStats = [
    {
      icon: <Speed className="stats-icon" />,
      number: '45%',
      label: 'Faster Learning',
      color: colors.warning,
      gradient: `linear-gradient(135deg, ${alpha(colors.warning, 0.1)} 0%, ${alpha(colors.warning, 0.05)} 100%)`
    },
    {
      icon: <Security className="stats-icon" />,
      number: '99.9%',
      label: 'Uptime',
      color: colors.accent,
      gradient: `linear-gradient(135deg, ${alpha(colors.accent, 0.1)} 0%, ${alpha(colors.accent, 0.05)} 100%)`
    }
  ];

  const handleFeatureAction = (action, title, value) => {
    console.log(`${action}:`, title, value);
  };

  return (
    <Box sx={{ py: 12, position: 'relative', overflow: 'hidden' }}>
      {/* Background decorative elements */}
      <Box
        sx={{
          position: 'absolute',
          top: '10%',
          right: '5%',
          width: 300,
          height: 300,
          background: `radial-gradient(circle, ${alpha(colors.primary, 0.04)} 0%, transparent 70%)`,
          borderRadius: '50%',
          animation: `${gentleFloat} 20s ease-in-out infinite`,
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '20%',
          left: '8%',
          width: 200,
          height: 200,
          background: `radial-gradient(circle, ${alpha(colors.accent, 0.04)} 0%, transparent 70%)`,
          borderRadius: '50%',
          animation: `${gentleFloat} 15s ease-in-out infinite reverse`,
          zIndex: 0,
        }}
      />

      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Chip
              icon={<AutoAwesome />}
              label="Platform Features"
              sx={{
                mb: 3,
                background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`,
                color: 'white',
                fontSize: '1rem',
                fontWeight: '600',
                py: 1,
                px: 3,
              }}
            />
            <Typography
              variant="h2"
              sx={{
                fontWeight: '900',
                color: colors.textPrimary,
                mb: 3,
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                background: `linear-gradient(135deg, ${colors.textPrimary} 0%, ${colors.primary} 100%)`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Everything You Need to{' '}
              <Box
                component="span"
                sx={{
                  background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`,
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                Succeed
              </Box>
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: colors.textSecondary,
                maxWidth: 800,
                mx: 'auto',
                fontSize: '1.2rem',
                lineHeight: 1.6,
              }}
            >
              Discover our comprehensive suite of tools designed to revolutionize your academic journey. 
              From smart learning management to collaborative study sessions, we've got you covered.
            </Typography>
          </Box>
        </motion.div>

        {/* Enhanced Features Grid */}
        <Grid container spacing={4} sx={{ mb: 12 }}>
          {features.map((feature, index) => (
            <Grid item xs={12} md={6} lg={6} key={index}>
              <SuperFeatureCard
                feature={feature}
                index={index}
                onLike={(title, liked) => handleFeatureAction('like', title, liked)}
                onBookmark={(title, bookmarked) => handleFeatureAction('bookmark', title, bookmarked)}
                onShare={(title) => handleFeatureAction('share', title)}
              />
            </Grid>
          ))}
        </Grid>

        {/* Platform Statistics */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: '800',
                color: colors.textPrimary,
                mb: 2,
                fontSize: { xs: '2rem', md: '2.8rem' },
              }}
            >
              Trusted by Students
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: colors.textSecondary,
                maxWidth: 600,
                mx: 'auto',
              }}
            >
              Join a thriving community of learners achieving academic excellence
            </Typography>
          </Box>

          <Grid container spacing={4} sx={{ mb: 12, justifyContent: 'center' }}>
            {platformStats.map((stat, index) => (
              <Grid item xs={6} md={3} key={index}>
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <StatsCard elevation={0} gradient={stat.gradient}>
                    <EnhancedIconContainer color={stat.color} sx={{ mx: 'auto', mb: 2 }}>
                      {stat.icon}
                    </EnhancedIconContainer>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: '900',
                        color: stat.color,
                        mb: 1,
                        fontSize: { xs: '2rem', md: '2.5rem' },
                      }}
                    >
                      {stat.number}
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        color: colors.textSecondary,
                        fontWeight: '600',
                      }}
                    >
                      {stat.label}
                    </Typography>
                  </StatsCard>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>

        {/* Why Choose Us Section */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <Grid container spacing={8} alignItems="center" sx={{ mb: 12 }}>
            <Grid item xs={12} md={6}>
              <Box>
                <Chip
                  icon={<Lightbulb />}
                  label="Why Choose Us"
                  sx={{
                    mb: 3,
                    background: `linear-gradient(135deg, ${colors.success} 0%, ${colors.successLight} 100%)`,
                    color: 'white',
                    fontSize: '0.9rem',
                    fontWeight: '600',
                  }}
                />
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: '800',
                    color: colors.textPrimary,
                    mb: 3,
                    fontSize: { xs: '2.2rem', md: '3rem' },
                    lineHeight: 1.2,
                  }}
                >
                  The Future of
                  <Box
                    component="span"
                    sx={{
                      background: `linear-gradient(135deg, ${colors.success} 0%, ${colors.successLight} 100%)`,
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    }}
                  >
                    {' '}Academic Excellence
                  </Box>
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    color: colors.textSecondary,
                    mb: 4,
                    lineHeight: 1.6,
                  }}
                >
                  Experience a revolutionary approach to learning that adapts to your unique style, 
                  connects you with peers, and accelerates your academic growth through cutting-edge technology.
                </Typography>

                {/* Feature highlights */}
                <Grid container spacing={3} sx={{ mb: 4 }}>
                  {[
                    { icon: <Groups />, title: 'Collaborative Learning', desc: 'Connect and learn with your peers' },
                    { icon: <CloudSync />, title: 'Cloud Synchronization', desc: 'Access your data anywhere, anytime' },
                    { icon: <MobileFriendly />, title: 'Mobile Optimized', desc: 'Perfect experience on all devices' },
                    { icon: <LiveHelp />, title: '24/7 Support', desc: 'Get help whenever you need it' }
                  ].map((item, idx) => (
                    <Grid item xs={12} sm={6} key={idx}>
                      <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: idx * 0.1 }}
                        viewport={{ once: true }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                          <Avatar
                            sx={{
                              width: 40,
                              height: 40,
                              background: `linear-gradient(135deg, ${colors.success} 0%, ${colors.successLight} 100%)`,
                              mt: 0.5,
                            }}
                          >
                            {React.cloneElement(item.icon, { sx: { fontSize: 20 } })}
                          </Avatar>
                          <Box>
                            <Typography
                              variant="subtitle1"
                              sx={{
                                fontWeight: '700',
                                color: colors.textPrimary,
                                mb: 0.5,
                              }}
                            >
                              {item.title}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                color: colors.textSecondary,
                                fontSize: '0.9rem',
                              }}
                            >
                              {item.desc}
                            </Typography>
                          </Box>
                        </Box>
                      </motion.div>
                    </Grid>
                  ))}
                </Grid>

                <InteractiveButton
                  variant="contained"
                  size="large"
                  endIcon={<ChevronRight />}
                  sx={{
                    background: `linear-gradient(135deg, ${colors.success} 0%, ${colors.successLight} 100%)`,
                    px: 4,
                    py: 1.5,
                    fontSize: '1.1rem',
                    fontWeight: '700',
                    '&:hover': {
                      background: `linear-gradient(135deg, ${alpha(colors.success, 0.9)} 0%, ${alpha(colors.successLight, 0.9)} 100%)`,
                      boxShadow: `0 12px 32px ${alpha(colors.success, 0.35)}`
                    }
                  }}
                >
                  Learn More
                </InteractiveButton>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <motion.div
                animate={{ 
                  y: [0, -10, 0],
                }}
                transition={{
                  repeat: Infinity,
                  duration: 4,
                  ease: "easeInOut"
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    background: `linear-gradient(135deg, ${alpha(colors.success, 0.1)} 0%, ${alpha(colors.successLight, 0.1)} 100%)`,
                    borderRadius: '32px',
                    p: 4,
                    border: `1px solid ${alpha(colors.success, 0.2)}`,
                    boxShadow: `0 20px 60px ${alpha(colors.success, 0.15)}`,
                    backdropFilter: 'blur(20px)',
                  }}
                >
                  {/* Decorative elements */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 20,
                      right: 20,
                      width: 60,
                      height: 60,
                      background: `linear-gradient(135deg, ${colors.success} 0%, ${colors.successLight} 100%)`,
                      borderRadius: '16px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      animation: `${breathe} 4s ease-in-out infinite`,
                    }}
                  >
                    <RocketLaunch sx={{ color: 'white', fontSize: 28 }} />
                  </Box>

                  {/* Mock interface elements */}
                  <Box sx={{ mt: 8 }}>
                    {[1, 2, 3].map((item) => (
                      <motion.div
                        key={item}
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: item * 0.2 }}
                        viewport={{ once: true }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            p: 2,
                            mb: 2,
                            background: colors.card,
                            borderRadius: '16px',
                            border: `1px solid ${colors.border}`,
                            boxShadow: `0 4px 20px ${colors.shadow}`,
                          }}
                        >
                          <Avatar
                            sx={{
                              width: 36,
                              height: 36,
                              background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryLight} 100%)`,
                            }}
                          >
                            <CheckCircle sx={{ fontSize: 18, color: 'white' }} />
                          </Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: '600', color: colors.textPrimary, mb: 0.5 }}
                            >
                              Feature {item} Completed
                            </Typography>
                            <LinearProgress
                              variant="determinate"
                              value={100}
                              sx={{
                                height: 6,
                                borderRadius: 3,
                                backgroundColor: alpha(colors.success, 0.1),
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: colors.success,
                                  borderRadius: 3,
                                }
                              }}
                            />
                          </Box>
                        </Box>
                      </motion.div>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          </Grid>
        </motion.div>

        {/* Call to Action Section */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <GradientCTASection>
            <Container maxWidth="md" sx={{ position: 'relative', zIndex: 2 }}>
              <Typography
                variant="h2"
                sx={{
                  fontWeight: '900',
                  mb: 3,
                  fontSize: { xs: '2.5rem', md: '3.5rem' },
                  textShadow: '0 4px 20px rgba(0,0,0,0.3)',
                }}
              >
                Ready to Transform Your
                <br />
                Academic Journey?
              </Typography>
              
              <Typography
                variant="h6"
                sx={{
                  mb: 5,
                  opacity: 0.95,
                  fontSize: '1.3rem',
                  lineHeight: 1.6,
                  textShadow: '0 2px 10px rgba(0,0,0,0.2)',
                }}
              >
                Join thousands of students who have already discovered the power of intelligent learning. 
                Start your journey towards academic excellence today with our comprehensive platform.
              </Typography>
              
              <Box
                sx={{
                  display: 'flex',
                  gap: 3,
                  justifyContent: 'center',
                  flexDirection: { xs: 'column', sm: 'row' },
                }}
              >
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <InteractiveButton
                    variant="contained"
                    size="large"
                    endIcon={<RocketLaunch />}
                    sx={{
                      px: 5,
                      py: 2,
                      fontSize: '1.2rem',
                      fontWeight: '700',
                      background: alpha('#ffffff', 0.2),
                      color: 'white',
                      border: `2px solid ${alpha('#ffffff', 0.3)}`,
                      backdropFilter: 'blur(10px)',
                      '&:hover': {
                        background: alpha('#ffffff', 0.3),
                        transform: 'translateY(-3px)',
                        boxShadow: `0 20px 50px ${alpha('#000000', 0.3)}`,
                      },
                    }}
                  >
                    Get Started Free
                  </InteractiveButton>
                </motion.div>
                
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <InteractiveButton
                    variant="outlined"
                    size="large"
                    startIcon={<PlayArrow />}
                    sx={{
                      px: 5,
                      py: 2,
                      fontSize: '1.2rem',
                      fontWeight: '700',
                      color: 'white',
                      borderColor: alpha('#ffffff', 0.5),
                      borderWidth: 2,
                      '&:hover': {
                        borderWidth: 2,
                        borderColor: '#ffffff',
                        background: alpha('#ffffff', 0.1),
                        backdropFilter: 'blur(10px)',
                      },
                    }}
                  >
                    Watch Demo
                  </InteractiveButton>
                </motion.div>
              </Box>
            </Container>
          </GradientCTASection>
        </motion.div>
      </Container>
    </Box>
  );
};

// Named export
export { HomeContent };

// Default export  
export default HomeContent;